import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Input,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { WorkOrderNoteForm } from './WorkOrderNoteForm';
import { WorkOrderFollowUp } from './WorkOrderFollowUp';
import { WorkOrderClaimantJobs } from './WorkOrderClaimantJobs';
import { WorkOrderPrintPreview } from './WorkOrderPrintPreview';
import { RepFormSearch } from './RepFormSearch';
import { ClaimantFormSearch } from './ClaimantFormSearch';
import { InterpreterFormSearch } from './InterpreterFormSearch';
import { ProviderFormSearch } from './ProviderFormSearch';
import { ClientForm } from './ClientForm';

import { WorkOrderTransportationForm } from './WorkOrderTransportationForm';
import { WorkOrderJobInvLine } from './WorkOrderJobInvLine';

import { RepForm } from './RepForm';
import { ClaimantForm } from './ClaimantForm';
import { InterpreterForm } from './InterpreterForm';

import { WorkOrderFormTableJobHistory } from './WorkOrderFormTableJobHistory';
import { WorkOrderFormTableReceivables } from './WorkOrderFormTableReceivables';
import { TroubleTicketForm } from './TroubleTicketForm';

import { FetchFile, FetchData, UploadFile } from './utils/DataFetch';
import { GetCookie, Timeout, openFileInNewTab } from './utils/Common';

import ReactTooltip from 'react-tooltip';

import DeleteIcon from '../images/delete.png';
import DownIcon from '../images/down.png';
import DownloadIcon from '../images/download-icon.png';
import UpIcon from '../images/up.png';


const moment = require('moment');

export class WorkOrderForm extends Component {
  static displayName = WorkOrderForm.name;

  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));
    this.draggableRef = React.createRef();
    const startDateTimeOriginal = this.getStartDateTimeSnapshot(props.model || {});
    // Initialize state with props.model, but if update, fetch latest from DB
    this.state = {
      isMounted: false,
      modal: this.props.modal,
      isFollowup: this.props.isFollowup,
      followupOriginJobId: this.props.followupOriginJobId,
      alert: this.props.alert,
      deltaPosition: { x: 0, y: 0 },
      hasSpecialBillingJobHistory: false,
      modalRepSearchForm: false,
      searchRepName: '',
      modalClaimantSearchForm: false,
      searchClaimantName: '',
      modalInterpreterSearchForm: false,
      searchInterpreterName: '',
      modalProviderSearchForm: false,
      searchProviderName: '',
      modalClient: false,
      modalTransportation: false,
      modalRep: false,
      modalClaimant: false,
      modalInterpreter: false,
      modalFollowUp: false,
      modalPrintPreview: false,
      modalClaimantJobs: false,
      modalTroubleTicket: false,
      startDateTimeChanged: 0,
      startDateTimeOriginal,
      model: props.model,
      workOrderList: props.workOrderList,
      jobHistoryList: props.jobHistoryList,
      jobInvLineList: props.jobInvLineList,
      interpreterList: [],
      remoteTypeList: JSON.parse(localStorage.getItem('RemoteTypes')),
      remoteHostList: JSON.parse(localStorage.getItem('RemoteHosts')),
      jobTypeList: JSON.parse(localStorage.getItem('JobTypes')),
      modalWorkOrderNoteForm: false,
      modalWorkOrderJobInvLine: false,
      forceUpdateCounter: 0,
      selectedIndex: props.selectedIndex,
      jobTypeText: '',
      jobHistory: {
        JobHistoryId: null,
        JobId: null,
        JobHistoryName: '',
        Description: '',
        Contact: '',
        ContactEmail: '',
        FileName: '',
        FileLocation: '',
        JobHistoryType: 'Job Note',
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        FormFile: null,
      },
      transportation: {
        EventType: 'insert',
        TransportationId: null,
        JobId: null,
        JobNum: null,
        CallerState: '',
        FailedTransportFlg: false,
        CallerName: '',
        AuthorizedBy: '',
        CallerEmail: '',
        CallerCompany: '',
        CallerPhone: '',
        AmbulatoryFlg: false,
        RoundTripFlg: false,
        Ground: null,
        AirFlg: false,
        LodgingFlg: false,
        Other: '',
      },
      rep: {
        EventType: 'update',
        RepId: null,
        ClientId: null,
        RepLastName: '',
        RepFirstName: '',
        RepPhone: '',
        RepPhone2: '',
        RepNote: '',
        RepZip: '',
        RepEmail: '',
        RepInactiveFlg: false,
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: '',
        ClientAbbrv: '',
        ClientPhone: '',
        ClientPhone2: '',
        ClientEmail: '',
      },
      claimant: {
        EventType: 'update',
        ClmId: null,
        RepId: null,
        ClientId: null,
        ClmLastName: '',
        ClmFirstName: '',
        ClmClaimNumber: '',
        ClmClaimNumberNoDash: '',
        ClmPhone: '',
        ClmInvoiceType: '',
        ClmInvoiceCaption: '',
        ClmLanguage: '',
        ClmNote: '',
        ClmWCABNumber: '',
        ClmInsuredParty: '',
        ClmEmployer: '',
        ClmDateOfInjuryStart: '',
        ClmDateOfInjuryEnd: '',
        ClmDateOfInjury: '',
        ClmDateOfInjuryStart: null,
        ClmDateOfInjuryEnd: null,
        ClmDateOfLoss: '',
        ClmDateOfLossDate: null,
        ClmStreet: '',
        ClmCity: '',
        ClmState: '',
        ClmZip: '',
        ClmEmail: '',
        ClmHasAttorney: false,
        ClmSSN: '',
        ClmDOB: null,
        ClmDiagnosis: '',
        ClmGender: '',
        ClmAppAtty: '',
        ClmAppAttyFirm: '',
        ClmAppAttyEmail: '',
        ClmAppAttyPhone: '',
        ClmDefAtty: '',
        ClmDefAttyFirm: '',
        ClmDefAttyEmail: '',
        ClmDefAttyPhone: '',
        ClmOrderedByName: '',
        ClmHeight: '',
        ClmWeight: '',
        ClmStatus: '',
        CreateDateTime: null,
        CreatebyUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        ClientName: '',
        ClientAbbrv: '',
        RepFirstName: '',
        RepLastName: '',
      },
      interpreter: {
        EventType: 'update',
        IntId: null,
        IntLastName: '',
        IntFirstName: '',
        IntGender: '',
        IntPronoun: '',
        IntEmail: '',
        IntCellTxt: '',
        IntPhoneOnly: '',
        IntFax: '',
        IntBeeper: '',
        IntStreet: '',
        IntCity: '',
        IntState: '',
        IntZip: '',
        IntCountry: '',
        IntSSINumber: '',
        IntActiveFlg: false,
        IntCorporationFlg: false,
        DBA: '',
        InHouseFlg: false,
        UnVettedFlg: false,
        EmergencyContact: '',
        UnavailableReason: '',
        BankName: '',
        BankAccount: '',
        BankRoute: '',
        Rate: null,
        HourMinimum: null,
        Prorate: '',
        ConfCallRate: null,
        BusinessCardRequestDate: null,
        BusinessCardRequestToProcessFlg: false,
        IntNote: '',
        ReferredBy: '',
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        CreatedBy: '',
        UpdatedBy: '',
      },
      client: {
        EventType: 'update',
        ClientId: null,
        ClientAbbrv: '',
        ClientPhone: '',
        ClientPhone2: '',
        ClientPhoneFax: '',
        ClientName: '',
        ClientMailStreet: '',
        ClientMailStreet2: '',
        ClientMailCity: '',
        ClientMailState: '',
        ClientMailZip: '',
        ClientStreet: '',
        ClientStreet2: '',
        ClientCity: '',
        ClientState: '',
        ClientZip: '',
        ClientCountry: '',
        ClientDiscount: null,
        ClientNotes: '',
        ClientCreditCard: '',
        ClientEmailForInvoice: '',
        ClientEmail: '',
        ClientWebsite: '',
        ClientOrg: '',
        ClientBillRateType: '',
        ClientInactiveFlg: false,
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
      searchModel: {
        IntId: '',
        ClmId: '',
        JobNum: null,
        StartDate: null,
        EndDate: '',
        Claimant: '',
        ClaimantNum: '',
        CLMPhone: '',
        Interpreter: '',
        Rep: '',
        ClientAbbrv: '',
        ProviderName: '',
        CreatedByUserId: null,
        MyJobs: false,
        MyJobsUser: '',
        SortBy: '',
        SortDirection: '',
      },
      jobInvLine: {
        EventType: 'insert',
        JobInvLineId: null,
        JobId: this.props.model.JobId,
        JobInvLineCodeId: null,
        LineDescription: '',
        LinePersonnel: '',
        LineRate: '',
        Amount: null,
        CreateByUserId: null,
        CreateDateTime: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
      },
    };

    // Core form functionality
    this.setModal = this.setModal.bind(this);
    // this.onSave = this.onSave.bind(this);
    this.onSaveWithoutClosing = this.onSaveWithoutClosing.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.handleOnKeyup = this.handleOnKeyup.bind(this);
    // this.handleNumberFieldBlur = this.handleNumberFieldBlur.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleTimeFieldChange = this.handleTimeFieldChange.bind(this);
    this.handleJobTimeFieldChange = this.handleJobTimeFieldChange.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    this.printWorkOrder = this.printWorkOrder.bind(this);
    this.setNextPrevData = this.setNextPrevData.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.showMap = this.showMap.bind(this);
    this.getSameDayAppointments = this.hasSameDayAppointments.bind(this);
    // this.onSave = this.onSave.bind(this);
    this.onSaveWithoutClosing = this.onSaveWithoutClosing.bind(this);

    // Search functionality
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);

    // Job Description functionality
    this.handleInsertJobInvLineConferenceCall =
      this.handleInsertJobInvLineConferenceCall.bind(this);
    this.handleInsertJobInvLineMessagePhone =
      this.handleInsertJobInvLineMessagePhone.bind(this);
    this.handleInsertJobInvLinePhone =
      this.handleInsertJobInvLinePhone.bind(this);
    this.handleInsertJobInvLineMedExam =
      this.handleInsertJobInvLineMedExam.bind(this);
    this.handleInsertJobInvLineSurgery =
      this.handleInsertJobInvLineSurgery.bind(this);
    this.setModalWorkOrderJobInvLine =
      this.setModalWorkOrderJobInvLine.bind(this);
    this.handleEditJobInvLineClick = this.handleEditJobInvLineClick.bind(this);
    this.handleDeleteJobInvLineClick =
      this.handleDeleteJobInvLineClick.bind(this);
    this.handleDeleteJobInvLineClick =
      this.handleDeleteJobInvLineClick.bind(this);
    this.handleSaveEventWorkOrderJobInvLineSuccess =
      this.handleSaveEventWorkOrderJobInvLineSuccess.bind(this);
    this.jobHasBillingLines = this.jobHasBillingLines.bind(this);
    this.getJobInvLine = this.getJobInvLine.bind(this);
    this.handleInsertJobInvLineRecordedStatement =
      this.handleInsertJobInvLineRecordedStatement.bind(this);
    this.handleInsertJobInvLinePhysTherapy =
      this.handleInsertJobInvLinePhysTherapy.bind(this);
    this.handleInsertJobInvLinePsychTherapy =
      this.handleInsertJobInvLinePsychTherapy.bind(this);

    // Job Notes functionality
    this.handleNewJobNoteClick = this.handleNewJobNoteClick.bind(this);
    this.handleNewJobNoteViewClick = this.handleNewJobNoteViewClick.bind(this);
    this.handleDeleteJobHistory = this.handleDeleteJobHistory.bind(this);
    this.handleSaveNote = this.handleSaveNote.bind(this);
    this.setModalWorkOrderNoteForm = this.setModalWorkOrderNoteForm.bind(this);
    this.handleSaveEventWorkOrderNoteFormSuccess =
      this.handleSaveEventWorkOrderNoteFormSuccess.bind(this);
    this.getJobHistory = this.getJobHistory.bind(this);

    // Rep functionality
    this.setModalRepFormSearch = this.setModalRepFormSearch.bind(this);
    this.handleSearchRepKeyDown = this.handleSearchRepKeyDown.bind(this);
    this.handleSelectRep = this.handleSelectRep.bind(this);
    this.handleRepNameClick = this.handleRepNameClick.bind(this);
    this.setModalRepForm = this.setModalRepForm.bind(this);
    this.handleSaveEventRepFormSuccess =
      this.handleSaveEventRepFormSuccess.bind(this);

    // Claimant functionality
    this.setModalClaimantFormSearch =
      this.setModalClaimantFormSearch.bind(this);
    this.handleSearchClaimantKeyDown =
      this.handleSearchClaimantKeyDown.bind(this);
    this.handleSelectClaimant = this.handleSelectClaimant.bind(this);
    this.handleClaimantNameClick = this.handleClaimantNameClick.bind(this);
    this.setModalClaimantForm = this.setModalClaimantForm.bind(this);
    this.handleSaveEventClaimantFormSuccess =
      this.handleSaveEventClaimantFormSuccess.bind(this);

    // Interpreter functionality
    this.setModalInterpreterFormSearch =
      this.setModalInterpreterFormSearch.bind(this);
    this.handleSearchInterpreterKeyDown =
      this.handleSearchInterpreterKeyDown.bind(this);
    this.handleSelectInterpreter = this.handleSelectInterpreter.bind(this);
    this.handleUpdatedInterpreter = this.handleUpdatedInterpreter.bind(this);
    this.handleInterpreterNameClick =
      this.handleInterpreterNameClick.bind(this);
    this.setModalInterpreterForm = this.setModalInterpreterForm.bind(this);
    this.handleSaveEventInterpreterFormSuccess =
      this.handleSaveEventInterpreterFormSuccess.bind(this);
    this.cancelIntConfirmed = this.cancelIntConfirmed.bind(this);

    // Provider functionality
    this.setModalProviderFormSearch =
      this.setModalProviderFormSearch.bind(this);
    this.handleSearchProviderKeyDown =
      this.handleSearchProviderKeyDown.bind(this);
    this.handleSelectProvider = this.handleSelectProvider.bind(this);

    // Client functionality
    this.setModalClient = this.setModalClient.bind(this);
    this.showClient = this.showClient.bind(this);
    this.handleSaveEventClientSuccess =
      this.handleSaveEventClientSuccess.bind(this);

    // Transportation functionality
    this.setModalTransportation = this.setModalTransportation.bind(this);
    this.handleTransportationClick = this.handleTransportationClick.bind(this);
    this.handleSaveEventWorkOrderTransportationFormSuccess =
      this.handleSaveEventWorkOrderTransportationFormSuccess.bind(this);

    // Other modal functionality
    this.setModalFollowup = this.setModalFollowup.bind(this);
    this.setModalPrintPreview = this.setModalPrintPreview.bind(this);
    this.setModalClaimantJobs = this.setModalClaimantJobs.bind(this);
    this.setModalTroubleTicket = this.setModalTroubleTicket.bind(this);
    this.openTroubleTicketForm = this.openTroubleTicketForm.bind(this);
    this.handleSaveTroubleTicketSuccess =
      this.handleSaveTroubleTicketSuccess.bind(this);

    // File handling
    this.handleViewJobHistoryFile = this.handleViewJobHistoryFile.bind(this);
    this.handleOpenJobFromHistory = this.handleOpenJobFromHistory.bind(this);
    this.handleViewInvoice = this.handleViewInvoice.bind(this);

    // Billing functionality
    this.interpreterHasBillingInfo = this.interpreterHasBillingInfo.bind(this);
    this.jobHasBillingLines = this.jobHasBillingLines.bind(this);
    this.interpreterHasBillingInfo = this.interpreterHasBillingInfo.bind(this);

    // Shared functionality
    this.hasSameDayAppointmentsClaimant =
      this.hasSameDayAppointments.bind(this);

    //
    if (this.props.model.EventType === 'update') {
      this.getJobHistory(this.props.model.JobId);
      this.getJobInvLine(this.props.model.JobId);
    }

    this.callerNoteRef = React.createRef();
  }

  isUpdateEventType(eventType) {
    return (eventType || '').toString().toLowerCase() === 'update';
  }

  normalizeJobDateValue(jobDateTime) {
    if (jobDateTime === null || jobDateTime === undefined || jobDateTime === '') {
      return '';
    }

    const parsedDate = moment(jobDateTime);
    if (parsedDate.isValid()) {
      return parsedDate.format('YYYY-MM-DD');
    }

    return String(jobDateTime).trim();
  }

  normalizeJobTimeValue(jobTime) {
    if (jobTime === null || jobTime === undefined) {
      return '';
    }

    const rawTime = String(jobTime).trim();
    if (rawTime === '') {
      return '';
    }

    const parsedTime = moment(
      rawTime,
      ['h:mm A', 'hh:mm A', 'H:mm', 'HH:mm', 'Hmm', 'HHmm'],
      true,
    );
    if (parsedTime.isValid()) {
      return parsedTime.format('h:mm A');
    }

    return rawTime.toUpperCase();
  }

  getStartDateTimeSnapshot(model) {
    const sourceModel = model || {};
    return {
      JobDateTime: this.normalizeJobDateValue(sourceModel.JobDateTime),
      JobTime: this.normalizeJobTimeValue(sourceModel.JobTime),
    };
  }

  getStartDateTimeChangedFlag(model, baseline) {
    if (!this.isUpdateEventType(model ? model.EventType : null)) {
      return 0;
    }

    const currentSnapshot = this.getStartDateTimeSnapshot(model);
    const originalSnapshot =
      baseline ||
      (this.state ? this.state.startDateTimeOriginal : null) || {
        JobDateTime: '',
        JobTime: '',
      };

    return currentSnapshot.JobDateTime !== (originalSnapshot.JobDateTime || '') ||
      currentSnapshot.JobTime !== (originalSnapshot.JobTime || '')
      ? 1
      : 0;
  }

  setModelWithStartDateTimeTracking(model) {
    const startDateTimeChanged = this.getStartDateTimeChangedFlag(model);
    this.setState({ model, startDateTimeChanged });
  }

  componentDidMount() {
    const model = { ...this.state.model };
    if (model.JobDateTime !== null) {
      model.JobDateTime = moment(model.JobDateTime).format('YYYY-MM-DD');
    }
    this.setState({
      isMounted: true,
      model,
      startDateTimeOriginal: this.getStartDateTimeSnapshot(model),
      startDateTimeChanged: 0,
    }); // Set isMounted to true when the component mounts

    // Set focus to the rep name field
    setTimeout(() => {
      if (this.callerNoteRef.current) {
        this.callerNoteRef.current.focus();
      }
    }, 100);

    // Remove any existing event listener first to prevent duplicates
    document.removeEventListener('keydown', this.keydownHandler);
    // Add the event listener
    document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  componentDidUpdate(prevProps) {
    ReactTooltip.rebuild();

    // Update state when specific props change to avoid clobbering more recent local updates
    if (
      prevProps.model !== this.props.model ||
      prevProps.jobInvLineList !== this.props.jobInvLineList ||
      prevProps.jobHistoryList !== this.props.jobHistoryList
    ) {
      const stateUpdates = {};
      if (prevProps.model !== this.props.model) {
        stateUpdates.model = this.props.model;
        stateUpdates.startDateTimeOriginal = this.getStartDateTimeSnapshot(
          this.props.model,
        );
        stateUpdates.startDateTimeChanged = 0;
      }
      if (prevProps.jobInvLineList !== this.props.jobInvLineList) {
        stateUpdates.jobInvLineList = this.props.jobInvLineList;
      }
      if (prevProps.jobHistoryList !== this.props.jobHistoryList) {
        stateUpdates.jobHistoryList = this.props.jobHistoryList;
      }

      if (Object.keys(stateUpdates).length > 0) {
        this.setState(stateUpdates);
      }
    }
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  setModal() {
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        this.props.setModal();
      },
    );
  }

  async onSaveWithoutClosing() {
    let model = { ...this.state.model };

    if (!model.RepId || model.RepId === '') {
      this.handleSaveEventSuccess({
        message: 'Rep is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (!model.ClmId || model.ClmId === '') {
      this.handleSaveEventSuccess({
        message: 'Claimant is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (!model.IntId || model.IntId === '') {
      this.handleSaveEventSuccess({
        message: 'Interpreter is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (!model.JobDateTime || model.JobDateTime === '') {
      this.handleSaveEventSuccess({
        message: 'Job Date and Time is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (model.JobTime === null || model.JobTime === '') {
      this.handleSaveEventSuccess({
        message: 'Job Date and Time is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (model.CallerType === null || model.CallerType === '') {
      this.handleSaveEventSuccess({
        message: 'Caller Type Cannot be null.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (model.RemType === null || model.RemType === '') {
      this.handleSaveEventSuccess({
        message: 'Remote Type is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (model.RemHost === null || model.RemHost === '') {
      this.handleSaveEventSuccess({
        message: 'Remote Host is required.',
        modal: true,
        color: 'warning',
      });
      return;
    } else if (
      this.state.model.ClmId === '' ||
      this.state.model.ClmId === null
    ) {
      this.handleSaveEventSuccess({
        message: 'Please choose Claimant.',
        modal: true,
        color: 'warning',
      });
      return;
    } else {
      // Validate time format for jobTime and finishTimeString
      const timeValidationResult = this.validateTimeFormat(
        this.state.model.JobTime,
      );
      if (!timeValidationResult.isValid) {
        this.handleSaveEventSuccess({
          message: timeValidationResult.errorMessage,
          modal: true,
          color: 'warning',
        });
        return;
      }

      // Update model with formatted time if needed
      if (timeValidationResult.formattedTime) {
        model.JobTime = timeValidationResult.formattedTime;
      }

      // Validate finish time format if present
      if (
        this.state.model.FinishTimeString &&
        this.state.model.FinishTimeString.trim() !== ''
      ) {
        const finishTimeValidationResult = this.validateTimeFormat(
          this.state.model.FinishTimeString,
        );
        if (!finishTimeValidationResult.isValid) {
          this.handleSaveEventSuccess({
            message: finishTimeValidationResult.errorMessage,
            modal: true,
            color: 'warning',
          });
          return;
        }

        // Update model with formatted finish time if needed
        if (finishTimeValidationResult.formattedTime) {
          model.FinishTimeString = finishTimeValidationResult.formattedTime;
        }
      }
      // -----------------------------------------------------
      // NEW CHECK: Is JobDateTime more than 2 years in the future?
      // -----------------------------------------------------
      const jobDateTime = moment(this.state.model.JobDateTime);
      if (jobDateTime.isAfter(moment().add(2, 'years'))) {
        const confirmMsg =
          'The job date is over 2 years in the future. Are you sure you want to save this record?';
        if (window.confirm(confirmMsg) === true) {
        } else return;
      }

      if (this.state.startDateTimeChanged === 1) {
        const confirmMsg =
          'Start date/time has changed. Are you sure you want to save this record?';
        if (window.confirm(confirmMsg) === false) {
          return;
        }
      }

      var strDay = moment(this.state.model.JobDateTime).format('dddd');

      if (strDay === 'Saturday' || strDay === 'Sunday') {
        if (
          window.confirm(
            'The appointment date is on ' +
              strDay +
              '. Are you sure you want to save this record?',
          ) === true
        ) {
        } else return;
      } else if (
        this.state.model.EventType === 'insert' &&
        this.state.jobTypeText !== 'Conf Call'
      ) {
        let hasSameDayApptClm = false;
        let hasSameDayApptInt = false;
        hasSameDayApptClm = await this.hasSameDayAppointments('claimant');
        if (
          this.state.model.IntLastName &&
          !this.state.model.IntLastName.startsWith('A ')
        ) {
          hasSameDayApptInt = await this.hasSameDayAppointments('interpreter');
        }
        if (hasSameDayApptClm === true) {
          if (
            window.confirm(
              'Claimant already has a job on this day. Are you sure you want to save this record?',
            ) === true
          ) {
          } else return;

          if (hasSameDayApptInt === true) {
            if (
              window.confirm(
                'Interpreter already has a job on this day. Are you sure you want to save this record?',
              ) === true
            ) {
            } else return;
          }
        }
      }
    }

    if (model.IntFee !== null) model.IntFee = parseInt(model.IntFee);
    if (model.IntFee === null) model.IntFee = 0;
    if (model.IntFeeOther !== null)
      model.IntFeeOther = parseInt(model.IntFeeOther);
    if (model.IntFeeOther === null) model.IntFeeOther = 0;
    if (model.IntOTFee !== null) model.IntOTFee = parseInt(model.IntOTFee);
    if (model.IntOTFee === null) model.IntOTFee = 0;
    if (model.FinishTimeString === '') model.FinishTimeString = ' ';

    const isInsertSave = model.EventType === 'insert';

    if (model.EventType === 'insert') {
      model.CreateByUserId = this.user.userid;
      model.CreatedBy = this.user.firstname + ' ' + this.user.lastname;
    } else if (model.EventType === 'update') {
      model.UpdateByUserId = this.user.userid;
    }

    const data = await FetchData(
      '/saveworkorder',
      'POST',
      this.user.token,
      model,
    );

    if (data.message === 'Success') {
      let updatedModel = { ...this.state.model };
      if (updatedModel.EventType === 'insert') {
        updatedModel.JobId = data.jobId;
        updatedModel.JobNum = data.jobNum;
        updatedModel.CreateDateTime = data.createDateTime;
        updatedModel.CreatedBy = this.user.firstname + ' ' + this.user.lastname;
        updatedModel.EventType = 'update';
      }

      // Update the state with the formatted times from the model that was sent to the backend
      updatedModel.JobTime = model.JobTime;
      updatedModel.FinishTimeString = model.FinishTimeString;

      // Keep the local model in sync for any follow-up job history record
      model.JobNum = updatedModel.JobNum;
      model.JobId = updatedModel.JobId;

      this.setState(
        {
          model: updatedModel,
          startDateTimeOriginal: this.getStartDateTimeSnapshot(updatedModel),
          startDateTimeChanged: 0,
        },
        () => {
          this.notifyParentModelUpdate(updatedModel);
        },
      );

      if (
        this.state.isFollowup === true &&
        isInsertSave &&
        this.state.followupOriginJobId
      ) {
        const formData = new FormData();
        formData.append('EventType', 'insert');
        formData.append('JobHistoryId', null);
        formData.append('JobId', this.state.followupOriginJobId);
        formData.append('JobHistoryName', '');
        formData.append(
          'Description',
          'Follow Up created Job # ' +
            model.JobNum +
            ' on ' +
            (model.JobDateTime || model.jobdatetime || ''),
        );
        formData.append('Contact', '');
        formData.append('ContactEmail', '');
        formData.append('FileLocation', '');
        formData.append('FileName', '');
        formData.append('JobHistoryType', 'Follow Up');
        formData.append(
          'CreateDateTime',
          moment().format('YYYY-MM-DD HH:mm:ss'),
        );
        formData.append('CreateByUserId', this.user.userid);
        formData.append('UpdateByUserId', null);
        formData.append('UpdateDateTime', null);
        //formData.append("IsDeletedFlg", model.IsDeletedFlg);
        formData.append('FormFile', model.FormFile);

        const followupResult = await UploadFile(
          '/savejobhistory',
          this.user.token,
          formData,
        );

        if (followupResult === 'Success') {
          this.props.handleSaveEventSuccess({
            message: followupResult,
            modal: false,
            color: 'success',
            model: model,
          });
        } else {
          this.handleSaveEventSuccess({
            message: followupResult,
            modal: true,
            color: 'warning',
          });
          return;
        }
      }

      const successAlert = {
        message: model.InvoicedFlg ? (
          <>
            Success<br />
            This is an Invoiced (Printed) Job. Not all fields will be saved.
          </>
        ) : data.message,
        modal: true,
        color: 'success',
      };
      this.handleSaveEventSuccess(successAlert);
      this.props.handleSaveEventSuccess(successAlert);
    } else {
      this.handleSaveEventSuccess({
        message: data.message,
        modal: data.message === 'Success' ? false : true,
        color: data.message === 'Success' ? 'success' : 'warning',
      });
    }
  }

  hasSameDayAppointments(entityType) {
    let entityIdName = '';
    let entityIdValue = '';
    if (entityType === 'claimant') {
      entityIdName = 'ClmId';
      entityIdValue = this.state.model.ClmId;
    } else {
      entityIdName = 'IntId';
      entityIdValue = this.state.model.IntId;
    }
    let sameDayApptModel = {
      [entityIdName]: entityIdValue,
      startDate: moment(this.state.model.JobDateTime).format('YYYY-MM-DD'),
    };
    let endPointName =
      entityType === 'claimant'
        ? '/getsamedayappointmentscountclaimant'
        : '/getsamedayappointmentscountinterpreter';
    return FetchData(
      endPointName,
      'POST',
      this.user.token,
      sameDayApptModel,
    ).then((data) => {
      let sameDayAppt = data;
      return sameDayAppt; // Return the data for use in the calling function
    });
  }

  async printWorkOrder() {
    let JobsList = [];
    let body = {
      JobIdsList: '',
    };

    let model = { ...this.state.model };
    JobsList.push(model.JobId);
    body.JobIdsList = JobsList.join();

    let workOrderFileName = 'WorkOrder_' + model.JobNum + '.pdf';

    await FetchFile('/getreportworkorder', 'POST', this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSaveEventSuccess({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        openFileInNewTab(blob, workOrderFileName);
      },
    );
  }

  handleSaveEventSuccess(alert) {
    // Only close the modal if alert.modal is strictly true (explicit close)
    if (alert.modal === true) {
      this.setState(
        {
          modal: false,
          alert: {
            color: alert.color,
            message: alert.message,
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    } else {
      // Keep modal open for all other cases (including modal: false or undefined)
      this.setState(
        {
          alert: {
            color: alert.color,
            message: alert.message,
            isOpen: true,
          },
        },
        () => {
          window.setTimeout(() => {
            this.setState({ alert: { isOpen: false } });
          }, Timeout(alert.message));
        },
      );
    }
  }

  async keydownHandler(e) {
    // Always allow ESC to close the modal, even in 'deletedjobs'
    if (
      e.keyCode === 27 &&
      this.props.modal &&
      !this.state.modalClaimantSearchForm &&
      !this.state.modalWorkOrderJobInvLine &&
      !this.state.modalClaimant &&
      !this.state.modalInterpreter &&
      !this.state.modalProviderSearchForm &&
      !this.state.modalFollowUp &&
      !this.state.modalWorkOrderNoteForm &&
      !this.state.modalInterpreterSearchForm &&
      !this.state.modalClaimantJobs &&
      !this.state.modalRepSearchForm &&
      !this.state.modalPrintPreview &&
      !this.state.modalTransportation &&
      !this.state.modalClient &&
      !this.state.modalRep &&
      !this.state.modalTroubleTicket
    ) {
      e.preventDefault();
      e.stopPropagation();
      this.setModal();
      return;
    }

    if (this.props.tableView !== 'deletedjobs') {
      if (
        e.keyCode === 83 &&
        e.altKey &&
        this.props.modal &&
        !this.state.modalClaimantSearchForm &&
        !this.state.modalWorkOrderJobInvLine &&
        !this.state.modalClaimant &&
        !this.state.modalInterpreter &&
        !this.state.modalProviderSearchForm &&
        !this.state.modalFollowUp &&
        !this.state.modalWorkOrderNoteForm &&
        !this.state.modalInterpreterSearchForm &&
        !this.state.modalRepSearchForm
      ) {
        // Alt+S
        e.preventDefault();
        e.stopPropagation();
        this.onSaveWithoutClosing();
      } else if (e.keyCode === 71 && e.altKey) {
        // ALT+G
        let model = { ...this.state.model };
        model.IntId = '237A27CF-1CD6-44CE-8128-DB09238E26C7';
        model.IntLastName = 'A CERT A';
        model.IntFirstName = '-';
        this.setState({ model });
      } else if (e.keyCode === 78 && e.altKey) {
        // ALT+N
        e.preventDefault();
        e.stopPropagation();
        let model = { ...this.state.model };
        model.IntId = '20CE8012-6DC4-4959-8E89-31F9D261383C';
        model.IntLastName = 'A NON CERT A';
        model.IntFirstName = '-';
        this.setState({ model });
      } else if (e.keyCode === 72 && e.altKey) {
        // ALT+H
        let model = { ...this.state.model };
        model.IntId = 'AC0AF063-3DF6-4D35-B074-EACEDA429BE4';
        model.IntLastName = 'A EXOTIC A';
        model.IntFirstName = '-';
        this.setState({ model });
      } else if (e.keyCode === 49 && e.altKey) {
        // ALT+1
        if (this.state.model.JobId !== null) this.setModalWorkOrderJobInvLine();
      } else if (e.keyCode === 88 && e.altKey) {
        // ALT+X
        let model = { ...this.state.model };
        model.JobDateTime = moment(new Date()).format('YYYY-MM-DD');
        this.setModelWithStartDateTimeTracking(model);
      } else if (e.keyCode === 84 && e.altKey) {
        // ALT+T
        let model = { ...this.state.model };
        model.JobTime = moment(new Date()).format('hh:mm A');
        this.setModelWithStartDateTimeTracking(model);
      } else if (e.keyCode === 81 && e.altKey) {
        // ALT+Q
        let model = { ...this.state.model };
        model.JobDateTime = '2011-11-11';
        model.JobTime = '1:11 PM'; //moment(new Date()).format('hh:mm A');
        this.setModelWithStartDateTimeTracking(model);
      } else if (e.keyCode === 82 && e.altKey) {
        // ALT+R
        this.setModalRepFormSearch();
      }
      //else if (e.keyCode === 87 && e.altKey) { // ALT+W
      //    this.printWorkOrder();

      //}
      else if (e.keyCode === 67 && e.altKey) {
        // ALT+C
        this.setModalClaimantFormSearch();
      } else if (e.keyCode === 73 && e.altKey) {
        // ALT+I
        this.setModalInterpreterFormSearch();
      } else if (e.keyCode === 80 && e.altKey) {
        // ALT+P
        this.setModalProviderFormSearch();
      } else if (e.keyCode === 66 && e.altKey) {
        // ALT+B - Save work order first, then perform billing
        try {
          // First save the work order
          await this.onSaveWithoutClosing();

          // Then proceed with billing logic
          let jobHasBillingLines = await this.jobHasBillingLines();
          let interpreterHasBilling = await this.interpreterHasBillingInfo();
          if (this.state.model.InvoicedFlg === true) {
            this.handleSaveEventSuccess({
              message: 'Job is already printed. Cannot add billing lines.',
              modal: false,
              color: 'warning',
            });
          } else {
            if (jobHasBillingLines === true) {
              this.handleSaveEventSuccess({
                message: 'Job already has JobLines.',
                modal: false,
                color: 'warning',
              });
            } else {
              if (interpreterHasBilling === false) {
                this.handleSaveEventSuccess({
                  message: 'Interpreter Payment Incomplete.',
                  modal: false,
                  color: 'warning',
                });
              } else {
                if (this.state.model.JobId !== null) {
                  FetchData(
                    '/BillingCalculateClientInvoice',
                    'POST',
                    this.user.token,
                    { JobId: this.state.model.JobId, UserId: this.user.userid },
                  ).then(async (data) => {
                    this.handleSaveEventSuccess({
                      message: data,
                      modal: false,
                      color: data === 'OK' ? 'success' : 'warning',
                    });
                    if (this.state.model.JobId) {
                      try {
                        const { jobTotal } = await this.getJobInvLine(
                          this.state.model.JobId,
                        );
                        const modelToSave = {
                          ...this.state.model,
                          JobTotal: jobTotal,
                          WorkFlowId: 'Invoicing',
                        };

                        await FetchData(
                          '/saveworkorder',
                          'POST',
                          this.user.token,
                          modelToSave,
                        );

                        this.notifyParentModelUpdate(modelToSave);
                      } catch (updateError) {
                        console.error(
                          'Error updating job total after autobilling:',
                          updateError,
                        );
                        this.handleSaveEventSuccess({
                          message:
                            'Billing completed, but job total failed to update. Please verify manually.',
                          modal: false,
                          color: 'warning',
                        });
                      }
                    }
                    this.props.refreshWorkOrderData(this.state.model.JobId);
                  });
                }
              }
            }
          }
        } catch (error) {
          console.error('Error during save and billing operation:', error);
          this.handleSaveEventSuccess({
            message: 'Error occurred while saving work order before billing.',
            modal: false,
            color: 'warning',
          });
        }
      } else if (e.keyCode === 65 && e.altKey) {
        // ALT+A
        let model = { ...this.state.model };
        model.CallerNote =
          model.CallerNote +
          ' ' +
          this.state.model.RepFirstName +
          ' ' +
          this.state.model.RepLastName;
        model.ProviderName =
          this.state.model.RepFirstName + ' ' + this.state.model.RepLastName;
        this.setState({ model });

        this.setState({ model });
      } else if (
        ((e.keyCode === 76 && e.altKey) || (e.keyCode === 49 && e.altKey)) &&
        !this.state.modalClaimantSearchForm
      ) {
        // ALT+L
        this.setModalWorkOrderJobInvLine();
      } else if (e.keyCode === 77 && e.altKey) {
        // ALT+M
        let model = { ...this.state.model };
        model.IntId = this.user.intid;
        model.IntFirstName = this.user.firstname;
        model.IntLastName = this.user.lastname;
        this.setState({ model });
      } else if (e.keyCode === 78 && e.altKey) {
        // ALT+N
        let model = { ...this.state.model };
        model.IntId = '20CE8012-6DC4-4959-8E89-31F9D261383C';
        model.IntFirstName = '-';
        model.IntLastName = 'A NON CERT';
        this.setState({ model });
      } else if (e.keyCode === 88 && e.altKey) {
        // ALT+X
        let model = { ...this.state.model };
        model.JobDateTime = moment(new Date()).format('YYYY-MM-DD');
        this.setModelWithStartDateTimeTracking(model);
      } else if (e.keyCode === 89 && e.altKey) {
        // ALT+Y
        if (this.state.model.ClmId !== null) this.handleClaimantNameClick();
      } else if (e.keyCode === 90 && e.altKey) {
        // ALT+Z
        if (this.state.model.JobId !== null) {
          var formData = new FormData();
          formData.append('EventType', 'insert');
          formData.append('JobHistoryId', null);
          formData.append('JobId', this.state.model.JobId);
          formData.append('Description', 'My Job');
          formData.append('JobHistoryType', 'My Job');
          formData.append('CreateByUserId', this.user.userid);

          UploadFile('/savejobhistory', this.user.token, formData).then(
            (data) => {
              this.handleSaveEventSuccess({
                message: data,
                modal: data === 'Success' ? false : true,
                color: data === 'Success' ? 'success' : 'warning',
              });
              this.getJobHistory(this.state.model.JobId);
            },
          );
        }
      } else if (e.keyCode === 85 && e.altKey) {
        // ALT+U
        if (this.state.model.JobId !== null) {
          this.setModalFollowup();
        }
      } else if (e.keyCode === 87 && e.altKey) {
        // ALT+W
        if (this.state.model.JobId !== null) {
          this.setModalPrintPreview();
        }
      } else if (e.keyCode === 50 && e.altKey) {
        // Alt+2
        this.handleInsertJobInvLineConferenceCall();
      } else if (e.keyCode === 51 && e.altKey) {
        //Alt+3
        this.handleInsertJobInvLineMessagePhone();
      } else if (e.keyCode === 52 && e.altKey) {
        //Alt+4
        this.handleInsertJobInvLinePhone();
      } else if (e.keyCode === 53 && e.altKey) {
        //Alt+5
        this.handleInsertJobInvLineRecordedStatement();
      } else if (e.keyCode === 54 && e.altKey) {
        //Alt+6
        this.handleInsertJobInvLinePhysTherapy();
      } else if (e.keyCode === 55 && e.altKey) {
        //Alt+7
        this.handleInsertJobInvLinePsychTherapy();
      } else if (e.keyCode === 56 && e.altKey) {
        //Alt+8
        this.handleInsertJobInvLineMedExam();
      } else if (e.keyCode === 57 && e.altKey) {
        //Alt+9
        this.handleInsertJobInvLineSurgery();
      } else if (e.keyCode === 74 && e.altKey) {
        // Alt+J
        if (this.state.model.JobId !== null) {
          this.setModalClaimantJobs();
        } else {
          if (
            this.state.model.ClmId === '' ||
            this.state.model.ClmId === null
          ) {
            this.handleSaveEventSuccess({
              message: 'Please choose Claimant.',
              modal: true,
              color: 'warning',
            });
          }
        }
      } else if (e.keyCode === 79 && e.altKey) {
        // Alt+O - Open new job note
        this.handleNewJobNoteClick();
      }
    }
  }

  async interpreterHasBillingInfo() {
    let searchModel = {
      IntId: this.state.model.IntId,
      ShowAll: true,
    };
    let interpreter = null;
    await FetchData(
      '/getinterpreters',
      'POST',
      this.user.token,
      searchModel,
    ).then((data) => {
      interpreter = data[0];
    });
    if (
      interpreter.rate === null ||
      interpreter.rate === 0 ||
      interpreter.hourMinimum === null ||
      interpreter.prorate === ''
    ) {
      return false;
    } else {
      return true;
    }
  }

  async jobHasBillingLines() {
    let searchModel = {
      JobId: this.state.model.JobId,
    };
    let jobBillingLines = [];
    await FetchData(
      '/getjobinvline',
      'POST',
      this.user.token,
      searchModel,
    ).then((data) => {
      jobBillingLines = data;
    });
    if (jobBillingLines.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  handleChange(e) {
    let model = { ...this.state.model };

    if (e.target.name === 'IntConfFlg') {
      e.preventDefault();
    } else if (e.target.type === 'checkbox')
      model[e.target.name] = e.target.checked;
    else if (e.target.type === 'number') {
      if (e.target.value !== '')
        model[e.target.name] = parseInt(e.target.value);
      else model[e.target.name] = null;
    } else if (e.target.name === 'CallerType')
      model[e.target.name] = parseInt(e.target.value);
    else {
      if (e.target.name === 'RemType') {
        if (e.target.value === 'd2f8a295-20e1-4653-b7c0-e456057cbd90') {
          // N/A
          model['RemHost'] = '64ecfbe8-9cb7-4af8-8a41-f756aaeaca39'; // N/A
          model['RemClaimFlg'] = true;
          model['RemIntFlg'] = true;
          model['RemProvFlg'] = true;
          model[e.target.name] = e.target.value;
        } else {
          model['RemHost'] = '';
          model['RemClaimFlg'] = false;
          model['RemIntFlg'] = false;
          model['RemProvFlg'] = false;
          model[e.target.name] = e.target.value;
        }
      } else {
        model[e.target.name] = e.target.value;
      }
    }

    this.setModelWithStartDateTimeTracking(model);
  }

  // handleOnKeyup(e) {
  //   let model = { ...this.state.model };
  //   if (/[^0-9]+/.test(e.target.value)) {
  //     model[e.target.name] = parseInt(e.target.value.replace(/[^0-9]*/g, ''));
  //   }
  //   this.setState({ model });
  // }

  // handleNumberFieldBlur(e) {
  //   let model = { ...this.state.model };
  //   if (e.target.value !== '') model[e.target.name] = parseInt(e.target.value);
  //   else model[e.target.name] = null;

  //   this.setState({ model });
  // }

  handleNewJobNoteViewClick(data) {
    this.setState((prevState) => ({
      jobHistory: {
        EventType: 'update',
        JobHistoryId: data.jobHistoryId,
        JobId: data.jobId,
        Name: data.name,
        Description: data.description,
        Contact: data.contact,
        ContactEmail: data.contactEmail,
        FileName: data.fileName,
        FileLocation: data.fileLocation,
        JobHistoryType: data.jobHistoryType,
        IsEditableFlg: data.isEditableFlg,
        CreateByUserId: data.createByUserId,
        FormFile: null,
      },
    }));
    this.setModalWorkOrderNoteForm();
  }

  getClmNumberLabel() {
    const labels = {
      CLM: 'Claim #:',
      FIL: 'File No:',
      POL: 'Policy No:',
      PO: 'P.O. No:',
      CAS: 'Case No:',
      SSN: 'SSN:',
      ID: 'ID No.:',
      REF: 'Ref No.:',
    };
    return labels[this.state.model.ClmInvoiceType] ?? 'Clm #:';
  }

  handleNewJobNoteClick() {
    this.setState((prevState) => ({
      jobHistory: {
        EventType: 'insert',
        JobHistoryId: null,
        JobId: this.state.model.JobId,
        Name: '',
        Description: '',
        Contact: '',
        ContactEmail: '',
        FileName: '',
        FileLocation: '',
        JobHistoryType: 'Job Note',
        CreateDateTime: null,
        CreateByUserId: null,
        UpdateByUserId: null,
        UpdateDateTime: null,
        IsDeletedFlg: false,
        IsEditableFlg: true,
        FormFile: null,
      },
    }));
    this.setModalWorkOrderNoteForm();
  }

  handleSaveNote(noteDetails) {
    let updatedModel = { ...this.state.model };
    if (noteDetails.JobHistoryType === 'Authorization') {
      updatedModel.RepAuthorizedFlg = true;
    } else if (noteDetails.JobHistoryType === 'To Booking Dept') {
      updatedModel.WorkFlowId = 'Booking';
    } else if (noteDetails.JobHistoryType === 'To Auth Dept') {
      updatedModel.WorkFlowId = 'Authorization';
    } else if (noteDetails.JobHistoryType === 'To Conf Dept') {
      updatedModel.WorkFlowId = 'Confirmation';
    } else if (noteDetails.JobHistoryType === 'Provider Conf') {
      updatedModel.ProvConfFlg = true;
    } else if (noteDetails.JobHistoryType === 'Int Cancelation') {
      updatedModel.IntConfFlg = false;
    } else if (noteDetails.JobHistoryType === 'Int Final Conf') {
      updatedModel.IntConfFlg = true;
    } else if (noteDetails.JobHistoryType === 'Claimant Confirmed') {
      updatedModel.ClmConfFlg = true;
    } else if (noteDetails.JobHistoryType === 'Remote Prov Conf') {
      updatedModel.RemProvFlg = true;
    } else if (noteDetails.JobHistoryType === 'Remote Int Conf') {
      updatedModel.RemIntFlg = true;
    } else if (noteDetails.JobHistoryType === 'Remote Clm Conf') {
      updatedModel.RemClaimFlg = true;
    } else if (noteDetails.JobHistoryType === 'Schedule Change') {
      updatedModel.RepAuthorizedFlg = false;
      updatedModel.IntConfFlg = false;
      updatedModel.ProvConfFlg = false;
    }
    // Update the model and ensure subsequent save uses the new state
    this.setState(
      (prevState) => ({
        model: updatedModel,
        forceUpdateCounter: prevState.forceUpdateCounter + 1,
      }),
      () => {
        this.onSaveWithoutClosing();
      },
    );
  }

  handleDeleteJobHistory(data) {
    if (window.confirm('Remove Job History?')) {
      var model = {
        JobHistoryId: data.jobHistoryId,
        UserId: this.user.userid,
      };

      FetchData('/deletejobhistory', 'POST', this.user.token, model).then(
        (data) => {
          if (data === 'Success') {
            this.handleSaveEventSuccess({
              message: data,
              modal: true,
              color: 'success',
            });
            this.getJobHistory(this.state.model.JobId);
          } else {
            this.handleSaveEventSuccess({
              message: data,
              modal: true,
              color: 'warning',
            });
          }
        },
      );
    }
  }

  handleInsertJobInvLineConferenceCall() {
    let jobModel = { ...this.state.model };
    let rate = 2.5;
    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else if (
      jobModel.FinishTimeString === null &&
      jobModel.FailedFlg === false
    ) {
      this.handleSaveEventSuccess({
        message: 'Finish time must have a value or F must be selected.',
        modal: false,
        color: 'warning',
      });
    } else {
      if (jobModel.ClmLanguage === 'Spanish') {
        rate = 1.5;
      }
      let jobTime = jobModel.JobTime;
      let finishTime = jobModel.FinishTimeString;
      let startTime = moment(jobTime, 'HH:mm A');
      let endTime = moment(finishTime, 'HH:mm A');
      let timeInMinutes = endTime.diff(startTime, 'minutes');
      let lineDescription = '';
      let lineRate = '';
      let amount = 0.0;
      let jobInvLineCodeId = '';

      if (timeInMinutes <= 10) {
        lineDescription = 'Conference Call';
        jobInvLineCodeId = '9e5e4810-c5a8-428b-8f7d-71422b6b77e3';
        lineRate = '@' + jobTime + ', min fee';
        amount = jobModel.ClmLanguage === 'Spanish' ? 15.0 : 25.0;
      } else if (jobModel.FailedFlg === true) {
        lineDescription = 'Phone Call';
        jobInvLineCodeId = 'ae3f84cc-e9bf-4865-81bc-4518889a17bb';
        lineRate = '@' + jobTime;
        amount = 0.0;
      } else {
        lineDescription = 'Conference Call';
        jobInvLineCodeId = '9e5e4810-c5a8-428b-8f7d-71422b6b77e3';
        lineRate =
          '@' +
          jobTime +
          ' to ' +
          jobModel.FinishTimeString +
          ' @$' +
          rate +
          '/min';
        amount = rate * timeInMinutes;
      }

      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: jobInvLineCodeId,
        LineDescription: lineDescription,
        LinePersonnel: jobModel.ProviderName,
        LineRate: lineRate,
        Amount: amount,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLineMessagePhone() {
    let jobModel = { ...this.state.model };
    let rate = 2.5;

    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else {
      let jobTime = jobModel.JobTime;
      let finishTime = jobModel.FinishTimeString;
      let startTime = moment(jobTime, 'HH:mm A');
      let endTime = moment(finishTime, 'HH:mm A');
      let timeInMinutes = endTime.diff(startTime, 'minutes');
      let lineDescription = '';
      let lineRate = '';
      let amount = 0.0;
      let jobInvLineCodeId = '';
      if (jobModel.ClmLanguage === 'Spanish') {
        rate = 1.5;
      }
      if (timeInMinutes <= 10) {
        lineDescription = 'Message Ph. Call';
        jobInvLineCodeId = 'aba975af-bcdc-4852-a731-e07647f9c766';
        lineRate = '@' + jobTime + ', min fee';
        amount = jobModel.ClmLanguage === 'Spanish' ? 15.0 : 25.0;
      } else {
        lineDescription = 'Message Ph. Call';
        jobInvLineCodeId = 'aba975af-bcdc-4852-a731-e07647f9c766';
        lineRate =
          '@' +
          jobTime +
          ' to ' +
          jobModel.FinishTimeString +
          ' @' +
          rate +
          '/min';
        amount = rate * timeInMinutes;
      }

      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: jobInvLineCodeId,
        LineDescription: lineDescription,
        LinePersonnel: jobModel.ProviderName,
        LineRate: lineRate,
        Amount: amount,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLinePhone() {
    let jobModel = { ...this.state.model };

    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else {
      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: 'ae3f84cc-e9bf-4865-81bc-4518889a17bb',
        LineDescription: 'Phone Call',
        LinePersonnel: jobModel.ProviderName,
        LineRate: '@' + jobModel.JobTime,
        Amount: 0.0,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLineRecordedStatement() {
    let jobModel = { ...this.state.model };
    let laborCodeRate = 1.5;

    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else if (
      (jobModel.FinishTimeString === null ||
        jobModel.FinishTimeString === '') &&
      jobModel.FailedFlg === false
    ) {
      this.handleSaveEventSuccess({
        message: 'Finish time must have a value or F must be selected.',
        modal: false,
        color: 'warning',
      });
    } else {
      // Calculate time difference in minutes
      let startTime = moment(jobModel.JobTime, 'HH:mm A');
      let finishTime = moment(jobModel.FinishTimeString, 'HH:mm A');
      let totalJobTimeInMinutes = finishTime.diff(startTime, 'minutes');
      let amount = totalJobTimeInMinutes * laborCodeRate;

      // If job failed or time is negative/zero, set default values
      if (jobModel.FailedFlg === true || totalJobTimeInMinutes <= 0) {
        this.handleSaveEventSuccess({
          message:
            'Cannot calculate time difference. Please check your start and finish times.',
          modal: false,
          color: 'warning',
        });
        return; // Early return to prevent further processing
      }

      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: '1cc94c22-dedb-43bd-886a-9ecdd8576813',
        LineDescription: 'Recorded Statement by phone',
        LinePersonnel: jobModel.ProviderName,
        LineRate:
          startTime.format('hh:mm A') +
          ' - ' +
          finishTime.format('hh:mm A') +
          ' @ $' +
          laborCodeRate +
          '/min',
        Amount: amount,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLinePhysTherapy() {
    let jobModel = { ...this.state.model };
    let laborCodeRate = 47.5;
    let LaborCodeMin = 2.5;
    let amount = LaborCodeMin * laborCodeRate;
    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else {
      // Calculate time difference in minutes

      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: 'f04b13ed-f4af-4b95-b3ad-8eee9d4d18a3',
        LineDescription: 'Phys.Therapy: INTERPRETER',
        LinePersonnel: jobModel.ProviderName,
        LineRate: '2.5 hr min @ $47.50/hr',
        Amount: amount,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLinePsychTherapy() {
    let jobModel = { ...this.state.model };
    let laborCodeRate = 47.5;
    let LaborCodeMin = 2.5;
    let amount = LaborCodeMin * laborCodeRate;
    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else {
      // Calculate time difference in minutes

      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: 'fcf96a92-12f7-4ed3-8b3e-6e8ea70fbee5',
        LineDescription: 'Psych.Therapy: INTERPRETER',
        LinePersonnel: jobModel.ProviderName,
        LineRate: '2.5 hr min @ $47.50/hr',
        Amount: amount,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLineMedExam() {
    let jobModel = { ...this.state.model };
    let laborCodeRate = 45.0;
    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else {
      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: '529d3ed1-5ccc-40df-a25b-b6ae7eca6660',
        LineDescription: 'Med Exam  INTERPRETER',
        LinePersonnel: jobModel.ProviderName,
        LineRate: '2.5 hr min @ $45/hr LABOR CODE', //LaborCodeRate
        Amount: 2.5 * laborCodeRate,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleInsertJobInvLineSurgery() {
    let jobModel = { ...this.state.model };
    let laborCodeRate = 45.0;
    if (!jobModel.JobId) {
      this.handleSaveEventSuccess({
        message:
          'Job line item cannot be added until work order has been saved.',
        modal: false,
        color: 'warning',
      });
    } else {
      let jobInvLineModel = {
        EventType: 'insert',
        JobId: jobModel.JobId,
        JobInvLineCodeId: '9587FDA7-A66B-41A6-9A19-1F591C74294E',
        LineDescription: 'Surgery INTERPRETER',
        LinePersonnel: jobModel.ProviderName,
        LineRate: '2.5 hr min @ $45/hr LABOR CODE',
        Amount: 2.5 * laborCodeRate,
        CreateByUserId: this.user.userid,
      };

      this.saveJobInvLine(jobInvLineModel);
    }
  }

  handleEditJobInvLineClick(jobInv) {
    this.setState((prevState) => ({
      jobInvLine: {
        EventType: 'update',
        JobInvLineId: jobInv.jobInvLineId,
        JobId: jobInv.jobId,
        JobInvLineCodeId: jobInv.jobInvLineCodeId,
        LineDescription: jobInv.lineDescription,
        LinePersonnel: jobInv.linePersonnel,
        LineRate: jobInv.lineRate,
        Amount: jobInv.amount,
        CreateByUserId: jobInv.createByUserId,
        CreateDateTime: jobInv.createDateTime,
        UpdateByUserId: jobInv.updateByUserId,
        UpdateDateTime: jobInv.updateDateTime,
        IsDeletedFlg: jobInv.isDeletedFlg,
      },
    }));
    this.setModalWorkOrderJobInvLine();
  }

  handleDeleteJobInvLineClick(jobInv) {
    const jobInvLineModel = {
      ...this.state.jobInvLine,
      EventType: 'delete',
      JobInvLineId: jobInv.jobInvLineId,
      JobId: jobInv.jobId || this.state.model.JobId,
      JobInvLineCodeId: jobInv.jobInvLineCodeId,
    };

    this.saveJobInvLine(jobInvLineModel);
  }

  setModalWorkOrderNoteForm() {
    this.setState({
      modalWorkOrderNoteForm: !this.state.modalWorkOrderNoteForm,
    });
  }

  setModalWorkOrderJobInvLine() {
    this.setState({
      modalWorkOrderJobInvLine: !this.state.modalWorkOrderJobInvLine,
    });
  }

  handleSearchFocus(e) {
    this.setState({
      searchRepName: '',
      searchClaimantName: '',
      searchInterpreterName: '',
      searchProviderName: '',
    });
    if (e.target.value !== '')
      this.setState({ [e.target.name]: e.target.value });
  }

  handleSearchChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSaveEventWorkOrderNoteFormSuccess(alert) {
    this.setState(
      {
        modalWorkOrderNoteForm: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
          if (
            alert.model.JobHistoryType === 'Authorization' ||
            alert.model.JobHistoryType === 'To Booking Dept' ||
            alert.model.JobHistoryType === 'To Auth Dept' ||
            alert.model.JobHistoryType === 'To Conf Dept' ||
            alert.model.JobHistoryType === 'Provider Conf' ||
            alert.model.JobHistoryType === 'Int Cancelation' ||
            alert.model.JobHistoryType === 'Int Final Conf' ||
            alert.model.JobHistoryType === 'Claimant Confirmed' ||
            alert.model.JobHistoryType === 'Remote Prov Conf' ||
            alert.model.JobHistoryType === 'Remote Clm Conf' ||
            alert.model.JobHistoryType === 'Remote Int Conf' ||
            alert.model.JobHistoryType === 'Schedule Change'
          ) {
            this.handleSaveNote(alert.model);
          }
          this.getJobHistory(this.state.model.JobId);
        });
      },
    );
  }

  handleSaveEventWorkOrderJobInvLineSuccess(alert) {
    this.setState(
      {
        modalWorkOrderJobInvLine: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });

          this.getJobInvLine(this.state.model.JobId);
        }, 3000);
      },
    );
  }

  handleSaveEventWorkOrderTransportationFormSuccess(alert) {
    this.setState(
      {
        modalTransportation: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, 3000);
      },
    );
  }

  handleTimeFieldChange(e) {
    var finishtime = e.target.value;

    // Validate time format - check if it matches valid "HH:MM AM/PM" format or 4-digit format
    var validTimeFormats = [
      /^\d{4}$/, // matches "1030" (4 digits)
      /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i, // matches "10:30 AM", "10:30AM", "1:30 PM", etc.
      /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, // matches "10:30", "13:30" (24-hour format)
    ];

    var isValidFormat = validTimeFormats.some((pattern) =>
      pattern.test(finishtime.trim()),
    );

    // Only validate if the field has content and isn't just being cleared
    if (finishtime.trim() !== '' && !isValidFormat) {
      this.handleSaveEventSuccess({
        message:
          'Invalid time format. Please use format like "10:30 AM" or "1030".',
        modal: false,
        color: 'warning',
      });
      // Set focus back to the input field after showing the error
      setTimeout(() => {
        e.target.focus();
        e.target.select();
      }, 100);
      return; // Exit early without processing the invalid time
    }

    let model = { ...this.state.model };
    model[e.target.name] = finishtime;

    this.setState({ model: model });
  }

  // Time validation helper method
  validateTimeFormat(timeValue) {
    if (!timeValue || timeValue.trim() === '') {
      return { isValid: true, formattedTime: null, errorMessage: null };
    }

    const timeString = timeValue.trim();

    // Check if time format is invalid (contains duplicate AM/PM)
    const invalidPattern = /(\d{1,2}):?(\d{2})?\s*(AM|PM)\s+(AM|PM)/i;
    if (invalidPattern.test(timeString)) {
      return {
        isValid: false,
        formattedTime: null,
        errorMessage: 'Invalid time format. Please use HH:MM AM/PM format.',
      };
    }

    // Check if it's 4 digits (like 1300)
    const fourDigitPattern = /^(\d{4})$/;
    const fourDigitMatch = timeString.match(fourDigitPattern);
    if (fourDigitMatch) {
      let hours = parseInt(fourDigitMatch[1].substring(0, 2));
      let minutes = parseInt(fourDigitMatch[1].substring(2, 4));

      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return {
          isValid: false,
          formattedTime: null,
          errorMessage: 'Invalid time format. Please use HH:MM AM/PM format.',
        };
      }

      // Convert to 12-hour format
      let ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      if (hours === 0) hours = 12;

      const formattedTime = `${hours}:${minutes
        .toString()
        .padStart(2, '0')} ${ampm}`;
      return {
        isValid: true,
        formattedTime: formattedTime,
        errorMessage: null,
      };
    }

    // Check if it's 8 characters (like 10:30 AM)
    const eightCharPattern = /^(\d{1,2}):(\d{2})\s+(AM|PM)$/i;
    const eightCharMatch = timeString.match(eightCharPattern);
    if (eightCharMatch) {
      let hours = parseInt(eightCharMatch[1]);
      let minutes = parseInt(eightCharMatch[2]);

      if (hours < 1 || hours > 12 || minutes < 0 || minutes > 59) {
        return {
          isValid: false,
          formattedTime: null,
          errorMessage: 'Invalid time format. Please use HH:MM AM/PM format.',
        };
      }

      // Format is already correct, just normalize case
      const formattedTime = `${hours}:${minutes
        .toString()
        .padStart(2, '0')} ${eightCharMatch[3].toUpperCase()}`;
      return {
        isValid: true,
        formattedTime: formattedTime,
        errorMessage: null,
      };
    }

    // If none of the patterns match, it's invalid
    return {
      isValid: false,
      formattedTime: null,
      errorMessage: 'Invalid time format. Please use HH:MM AM/PM format.',
    };
  }

  handleJobTimeFieldChange(e) {
    var jobtime = e.target.value;

    // Validate time format - check if it matches valid "HH:MM AM/PM" format or 4-digit format
    var validTimeFormats = [
      /^\d{4}$/, // matches "1030" (4 digits)
      /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i, // matches "10:30 AM", "10:30AM", "1:30 PM", etc.
      /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/, // matches "10:30", "13:30" (24-hour format)
    ];

    var isValidFormat = validTimeFormats.some((pattern) =>
      pattern.test(jobtime.trim()),
    );

    // Only validate if the field has content and isn't just being cleared
    if (jobtime.trim() !== '' && !isValidFormat) {
      this.handleSaveEventSuccess({
        message:
          'Invalid time format. Please use format like "10:30 AM" or "1030".',
        modal: true,
        color: 'warning',
      });
      // Set focus back to the input field after showing the error
      setTimeout(() => {
        e.target.focus();
        e.target.select();
      }, 100);
      return; // Exit early without processing the invalid time
    }

    var concatChar = e.target.value;
    var hour = '';
    var minutes = '';
    var amPm = '';

    if (jobtime.length === 4) {
      for (var i = 0, len = jobtime.length; i < len; i++) {
        if (i <= 1) hour += jobtime[i];
        else minutes += jobtime[i];
      }

      if (parseInt(hour) < 12)
        concatChar = parseInt(hour) + ':' + minutes + ' AM';
      else if (parseInt(hour) === 12)
        concatChar = parseInt(hour) + ':' + minutes + ' PM';
      else {
        concatChar = parseInt(hour) - 12 + ':' + minutes + ' PM';
      }
    } else if (jobtime.length === 8) {
      for (i = 0, len = jobtime.length; i < len; i++) {
        if (i <= 1) hour += jobtime[i];
        else if (i === 3 || i === 4) minutes += jobtime[i];
        else if (i === 6 || i === 7) amPm += jobtime[i];
      }

      if (parseInt(hour) < 12)
        concatChar = parseInt(hour) + ':' + minutes + ' ' + amPm;
      else if (parseInt(hour) === 12)
        concatChar = parseInt(hour) + ':' + minutes + ' ' + amPm;
      else {
        concatChar = parseInt(hour) - 12 + ':' + minutes + ' PM';
      }
    }

    let model = { ...this.state.model };
    model[e.target.name] = concatChar;
    this.setModelWithStartDateTimeTracking(model);
  }

  setNextPrevData(rowIndex) {
    const nextIndex = this.state.selectedIndex + rowIndex;

    if (nextIndex < 0) {
      this.handleSaveEventSuccess({
        message: 'Top of list reached',
        modal: false,
        color: 'warning',
      });
      return;
    }

    if (nextIndex >= this.state.workOrderList.length) {
      this.handleSaveEventSuccess({
        message: 'Bottom of list reached',
        modal: false,
        color: 'warning',
      });
      return;
    }

    this.setState(
      {
        jobHistoryList: [],
        jobInvLineList: [],
        model: [],
        selectedIndex: nextIndex,
      },
      () => {
        const woData = this.state.workOrderList[nextIndex];
        if (woData) this.setData(woData);
      },
    );
  }

  setData(woData) {
    FetchData(
      '/getworkorder?jobId=' + woData.jobId,
      'POST',
      this.user.token,
      null,
    ).then((data) => {
      this.setState(() => {
        const model = {
          EventType: 'update',
          JobNum: data.jobNum,
          JobId: data.jobId,
          JobDateTime: data.jobDateTime,
          JobTime: data.jobTime,
          FinishTime: data.finishTime,
          FinishTimeString:
            data.finishTimeString === null ? null : data.finishTimeString,
          FollowupDate: data.followupDate,
          ProvId: data.provId,
          ProviderName: data.providerName,
          ProvEmail: data.provEmail,
          ProvNote: data.provNote,
          IntApptNotes: data.intApptNotes,
          ConfCallNote: data.confCallNote,
          AptName: data.aptName,
          AptStreet: data.aptStreet,
          AptCity: data.aptCity,
          AptState: data.aptState,
          AptZip: data.aptZip,
          AptPhone: data.aptPhone,
          AptDirection: data.aptDirection,
          FailedFlg: data.failedFlg,
          CallerNote: data.callerNote,
          InvoiceNote: data.invoiceNote,
          IntCheckDate: data.intCheckDate,
          IntCheckNum: data.intCheckNum,
          InvoicedFlg: data.invoicedFlg,
          JobTotal: data.jobTotal,
          JobDiscount: data.jobDiscount,
          IntFee: data.intFee === null ? null : parseInt(data.intFee),
          IntFeeOther:
            data.intFeeOther === null ? null : parseInt(data.intFeeOther),
          IntOTFee: data.intOTFee === null ? null : parseInt(data.intOTFee),
          IntFeeNote: data.intFeeNote,
          TransportationFlg: data.transportationFlg,
          TransConfFlg: data.transConfFlg,
          IntConfFlg: data.intConfFlg,
          AppointmentTypeId: data.appointmentTypeId,
          CallerType: data.callerType,
          ProvConfFlg: data.provConfFlg,
          ClmConfFlg: data.clmConfFlg,
          IsDeletedFlg: data.isDeletedFlg,
          BillReviewedFlg: data.billReviewedFlg,
          AuditFlg: data.auditFlg,
          PurpleReportFlg: data.purpleReportFlg,
          RepAuthorizedFlg: data.repAuthorizedFlg,
          SelectedFlg: data.selectedFlg,
          ClmId: data.clmId,
          ClmFirstName: data.clmFirstName,
          ClmLastName: data.clmLastName,
          ClmClaimNumber: data.clmClaimNumber,
          ClmClaimNumberNoDash: data.clmClaimNumberNoDash,
          ClmPhone: data.clmPhone,
          ClmDateOfLoss: data.clmDateOfLoss,
          ClmDateOfLossDate: data.clmDateOfLossDate,
          ClmDateOfInjury: data.clmDateOfInjury,
          ClmDateOfInjuryStart: data.clmDateOfInjuryStart,
          ClmDateOfInjuryEnd: data.clmDateOfInjuryEnd,
          ClmNote: data.clmNote,
          ClmDOB: data.clmDOB,
          ClmInsuredParty: data.clmInsuredParty,
          ClmEmployer: data.clmEmployer,
          ClmInvoiceCaption: data.clmInvoiceCaption,
          ClmLanguage: data.clmLanguage,
          ClmWCABNumber: data.clmWCABNumber,
          ClmInvoiceType: data.clmInvoiceType,
          ClmStreet: data.clmStreet,
          ClmCity: data.clmCity,
          ClmState: data.clmState,
          ClmZip: data.clmZip,
          ClmSSN: data.clmSSN,
          ClmOrderedByName: data.clmOrderedByName,
          ClmDiagnosis: data.clmDiagnosis,
          ClmEmail: data.clmEmail,
          ClmHasAttorney: data.clmHasAttorney,
          RepId: data.repId,
          RepFirstName: data.repFirstName,
          RepLastName: data.repLastName,
          RepPhone: data.repPhone,
          RepEmail: data.repEmail,
          ClientId: data.clientId,
          ClientAbbrv: data.clientAbbrv,
          ClientName: data.clientName,
          ClientStreet: data.clientStreet,
          ClientStreet2: data.clientStreet2,
          ClientCity: data.clientCity,
          ClientState: data.clientState,
          ClientZip: data.clientZip,
          ClientMailStreet: data.clientMailStreet,
          ClientMailStreet2: data.clientMailStreet2,
          ClientMailCity: data.clientMailCity,
          ClientMailState: data.clientMailState,
          ClientMailZip: data.clientMailZip,
          ClientPhone: data.clientPhone,
          ClientPhoneFax: data.clientPhoneFax,
          ClientPhone2: data.clientPhone2,
          ClientEmail: data.clientEmail,
          ClientInactiveFlg: data.clientInactiveFlg,
          IntId: data.intId,
          IntLastName: data.intLastName,
          IntFirstName: data.intFirstName,
          IntCellTxt: data.intCellTxt,
          IntPhoneOnly: data.intPhoneOnly,
          IntEmail: data.intEmail,
          IntNote: data.intNote,
          InHouseFlg: data.inHouseFlg,
          IntCity: data.intCity,
          IntStreet: data.intStreet,
          IntState: data.intState,
          IntZip: data.intZip,
          DBA: data.dDBA,
          Rate: data.rate,
          HourMinimum: data.hourMinimum,
          Prorate: data.prorate,
          BankRoute: data.bankRoute,
          BankAccount: data.bankAccount,
          IntSSINumber: data.intSSINumber,
          FirstName: data.firstName,
          LastName: data.lastName,
          UserType: data.userType,
          UserIntId: data.userIntId,
          CreateDateTime: data.createDateTime,
          CreateByUserId: data.createByUserId,
          UpdateDateTime: data.updateDateTime,
          UpdateByUserId: data.updateByUserId,
          RemIntFlg: data.remIntFlg,
          RemClaimFlg: data.remClaimFlg,
          RemProvFlg: data.remProvFlg,
          RemFinalFlg: data.remFinalFlg,
          RemType: data.remType,
          RemTypeDesc: data.remTypeDesc,
          RemHost: data.remHost,
          RemHostDesc: data.remHostDesc,
          CreatedBy: data.createdBy,
          UpdatedBy: data.updatedBy,
          MyJobTJobHistory: data.myJobTJobHistory,
          MyJobWaitingOnCallBack: data.myJobWaitingOnCallBack,
          JobBalance: data.jobBalance,
          WorkFlowId: data.workFlowId,
        };

        return {
          model,
          startDateTimeOriginal: this.getStartDateTimeSnapshot(model),
          startDateTimeChanged: 0,
        };
      });
    });

    this.getJobHistory(woData.jobId);
    this.getJobInvLine(woData.jobId);
  }

  notifyParentModelUpdate(modelOverride) {
    if (typeof this.props.onModelChange !== 'function') {
      return;
    }

    const sourceModel = modelOverride || this.state.model;
    if (!sourceModel) {
      return;
    }

    this.props.onModelChange({ ...sourceModel });
  }

  getJobHistory(jobId) {
    let model = {
      JobId: jobId,
    };

    FetchData('/getjobhistory', 'POST', this.user.token, model).then((data) => {
      const jobHistoryList = Array.isArray(data) ? data : [];
      var hasSBilling = false;
      for (var val of jobHistoryList) {
        if (val.jobHistoryType === 'Special Billing') hasSBilling = true;
      }

      this.setState({
        jobHistoryList: jobHistoryList,
        hasSpecialBillingJobHistory: hasSBilling,
        fetchingData: false,
      });
    });
  }

  getJobInvLine(jobId) {
    const model = {
      JobId: jobId,
    };

    return FetchData('/getjobinvline', 'POST', this.user.token, model).then(
      (data) => {
        const jobTotal = data.reduce((acc, line) => {
          const amount =
            line.amount !== undefined && line.amount !== null
              ? Number(line.amount)
              : line.Amount !== undefined && line.Amount !== null
                ? Number(line.Amount)
                : 0;
          return acc + (Number.isFinite(amount) ? amount : 0);
        }, 0);

        const roundedTotal = Math.round(jobTotal * 100) / 100;

        return new Promise((resolve) => {
          this.setState(
            (prevState) => ({
              jobInvLineList: data,
              fetchingData: false,
              model: {
                ...prevState.model,
                JobTotal: roundedTotal,
              },
            }),
            () => {
              this.notifyParentModelUpdate();
              resolve({ jobInvLineList: data, jobTotal: roundedTotal });
            },
          );
        });
      },
    );
  }

  saveJobInvLine(jobInvLineModel) {
    const jobId = jobInvLineModel.JobId || this.state.model.JobId;

    return FetchData(
      '/savejobinvline',
      'POST',
      this.user.token,
      jobInvLineModel,
    )
      .then((data) => {
        this.handleSaveEventSuccess({
          message: data,
          modal: data === 'Success' ? false : true,
          color: data === 'Success' ? 'success' : 'warning',
        });

        if (data === 'Success' && jobId) {
          return this.getJobInvLine(jobId).then(({ jobTotal }) => {
            const modelToSave = {
              ...this.state.model,
              JobTotal: jobTotal,
            };

            return new Promise((resolve) => {
              this.setState({ model: modelToSave }, () => {
                this.notifyParentModelUpdate(modelToSave);
                resolve(data);
              });
            });
          });
        }

        return data;
      })
      .catch((error) => {
        console.error('Error saving job line:', error);
        this.handleSaveEventSuccess({
          message: 'Failed to save job line. Please try again.',
          modal: true,
          color: 'danger',
        });
        throw error;
      });
  }

  // Rep Search
  setModalRepFormSearch() {
    this.setState({ modalRepSearchForm: !this.state.modalRepSearchForm });
  }

  handleSearchRepKeyDown(e) {
    if (e.target.value !== '' && e.keyCode === 13) {
      this.setState({ searchRepName: e.target.value });
      this.setModalRepFormSearch();
    }
  }

  handleSelectRep(rep) {
    let model = this.state.model;

    model.RepId = rep.data.repId;
    model.RepFirstName = rep.data.repFirstName;
    model.RepLastName = rep.data.repLastName;
    model.RepEmail = rep.data.repEmail;
    model.RepPhone = rep.data.repPhone;

    model.ClientId = rep.data.clientId;
    model.ClientAbbrv = rep.data.clientAbbrv;
    model.ClientName = rep.data.clientName;
    model.ClientEmail = rep.data.clientEmail;
    model.ClientPhone = rep.data.clientPhone;

    this.setState({ model: model }, () => {
      this.setModalRepFormSearch();
      if (this.state.model.ClmId === '') this.setModalClaimantFormSearch();
    });
  }

  // Rep
  handleRepNameClick() {
    FetchData('/getreps', 'POST', this.user.token, {
      RepId: this.state.model.RepId,
    }).then((data) => {
      if (data.length > 0) {
        var repData = data[0];

        this.setState((prevState) => ({
          rep: {
            EventType: 'update',
            ClientId: repData.clientId,
            RepId: repData.repId,
            RepLastName: repData.repLastName,
            RepFirstName: repData.repFirstName,
            RepPhone: repData.repPhone,
            RepPhone2: repData.repPhone2,
            RepNote: repData.repNote,
            RepZip: repData.repZip,
            RepEmail: repData.repEmail,
            RepInactiveFlg: repData.repInactiveFlg,
            CreateDateTime: repData.createDateTime,
            CreatebyUserId: repData.createbyUserId,
            UpdateByUserId: repData.updateByUserId,
            UpdateDateTime: repData.updateDateTime,
            IsDeletedFlg: repData.isDeletedFlg,
            ClientName: repData.clientName,
            ClientAbbrv: repData.clientAbbrv,
            ClientPhone: repData.clientPhone,
            ClientPhone2: repData.clientPhone2,
            ClientEmail: repData.clientEmail,
          },
        }));
      } else {
        this.setState((prevState) => ({
          rep: {
            EventType: 'insert',
            RepId: null,
            ClientId: null,
            RepLastName: '',
            RepFirstName: '',
            RepPhone: '',
            RepPhone2: '',
            RepNote: '',
            RepZip: '',
            RepEmail: '',
            RepInactiveFlg: false,
            CreateDateTime: null,
            CreatebyUserId: null,
            UpdateByUserId: null,
            UpdateDateTime: null,
            IsDeletedFlg: false,
            ClientName: '',
            ClientAbbrv: '',
            ClientPhone: '',
            ClientPhone2: '',
            ClientEmail: '',
          },
        }));
      }

      this.setModalRepForm();
    });
  }

  setModalRepForm() {
    this.setState({ modalRep: !this.state.modalRep });
  }

  handleSaveEventRepFormSuccess(alert) {
    this.setState(
      {
        modalRep: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, 3000);
      },
    );
  }

  // Claimant
  handleClaimantNameClick() {
    if (this.state.model.ClmId !== null && this.state.model.ClmId !== '') {
      FetchData('/getclaimants', 'POST', this.user.token, {
        ClmId: this.state.model.ClmId,
      }).then((data) => {
        var claimantData = data[0];

        this.setState((prevState) => ({
          claimant: {
            EventType: 'update',
            ClmId: claimantData.clmId,
            RepId: claimantData.RepId,
            ClientId: claimantData.clientId,
            ClmLastName: claimantData.clmLastName,
            ClmFirstName: claimantData.clmFirstName,
            ClmClaimNumber: claimantData.clmClaimNumber,
            ClmClaimNumberNoDash: claimantData.clmClaimNumberNoDash,
            ClmPhone: claimantData.clmPhone,
            ClmInvoiceType: claimantData.clmInvoiceType,
            ClmInvoiceCaption: claimantData.clmInvoiceCaption,
            ClmLanguage: claimantData.clmLanguage,
            ClmNote: claimantData.clmNote,
            ClmWCABNumber: claimantData.clmWCABNumber,
            ClmInsuredParty: claimantData.clmInsuredParty,
            ClmEmployer: claimantData.clmEmployer,
            ClmDateOfInjuryStart: claimantData.clmDateOfInjuryStart,
            ClmDateOfInjuryEnd: claimantData.clmDateOfInjuryEnd,
            ClmDateOfInjury: claimantData.clmDateOfInjury,
            ClmDateOfInjuryStart: claimantData.clmDateOfInjuryStart,
            ClmDateOfInjuryEnd: claimantData.clmDateOfInjuryEnd,
            ClmDateOfLoss: claimantData.clmDateOfLoss,
            ClmDateOfLossDate: claimantData.clmDateOfLossDate,
            ClmStreet: claimantData.clmStreet,
            ClmCity: claimantData.clmCity,
            ClmState: claimantData.clmState,
            ClmZip: claimantData.clmZip,
            ClmEmail: claimantData.clmEmail,
            ClmHasAttorneyFlg: claimantData.clmHasAttorneyFlg,
            ClmSSN: claimantData.clmSSN,
            ClmDOB: claimantData.clmDOB,
            ClmDiagnosis: claimantData.clmDiagnosis,
            ClmGender: claimantData.clmGender,
            ClmAppAtty: claimantData.clmAppAtty,
            ClmAppAttyFirm: claimantData.clmAppAttyFirm,
            ClmAppAttyEmail: claimantData.clmAppAttyEmail,
            ClmAppAttyPhone: claimantData.clmAppAttyPhone,
            ClmDefAtty: claimantData.clmDefAtty,
            ClmDefAttyFirm: claimantData.clmDefAttyFirm,
            ClmDefAttyEmail: claimantData.clmDefAttyEmail,
            ClmDefAttyPhone: claimantData.clmDefAttyPhone,
            ClmOrderedByName: claimantData.clmOrderedByName,
            ClmHeight: claimantData.clmHeight,
            ClmWeight: claimantData.clmWeight,
            ClmStatus: claimantData.clmStatus,
            CreateDateTime: claimantData.createDateTime,
            CreatebyUserId: claimantData.createbyUserId,
            UpdateByUserId: claimantData.updateByUserId,
            UpdateDateTime: claimantData.updateDateTime,
            IsDeletedFlg: claimantData.isDeletedFlg,
            ClientName: claimantData.clientName,
            ClientAbbrv: claimantData.clientAbbrv,
            RepFirstName: claimantData.repFirstName,
            RepLastName: claimantData.repLastName,
          },
        }));
        this.setModalClaimantForm();
      });
    }
  }

  setModalClaimantForm() {
    this.setState({ modalClaimant: !this.state.modalClaimant });
  }

  handleSaveEventClaimantFormSuccess(alert) {
    this.setState(
      {
        modalClaimant: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
        ...(alert.model && {
          model: {
            ...this.state.model,
            ClmInvoiceType: alert.model.ClmInvoiceType,
          },
        }),
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, 3000);
      },
    );
  }

  // Claimant Search
  setModalClaimantFormSearch() {
    if (this.state.model.RepId === '' || this.state.model.RepId === null) {
      this.handleSaveEventSuccess({
        message: 'Please choose Rep first before choosing Claimant',
        modal: true,
        color: 'warning',
      });
    } else
      this.setState({
        modalClaimantSearchForm: !this.state.modalClaimantSearchForm,
      });
  }

  handleSearchClaimantKeyDown(e) {
    if (
      (this.state.model.RepId === '' || this.state.model.RepId === null) &&
      e.keyCode === 13
    ) {
      this.handleSaveEventSuccess({
        message: 'Please choose Rep first before choosing Claimant',
        modal: true,
        color: 'warning',
      });
    } else {
      if (e.target.value !== '' && e.keyCode === 13) {
        this.setState({ searchClaimantName: e.target.value });
        this.setModalClaimantFormSearch();
      }
    }
  }

  handleSelectClaimant(claimant) {
    let model = this.state.model;

    model.ClmId = claimant.data.clmId;
    model.ClmFirstName = claimant.data.clmFirstName;
    model.ClmLastName = claimant.data.clmLastName;
    model.ClmClaimNumber = claimant.data.clmClaimNumber;
    model.ClmClaimNumberNoDash = claimant.data.clmClaimNumberNoDash;
    model.ClmPhone = claimant.data.clmPhone;
    model.ClmDateOfLoss = claimant.data.clmDateOfLoss;
    model.ClmDateOfLossDate = claimant.data.clmDateOfLossDate;
    model.ClmDateOfInjury = claimant.data.clmDateOfInjury;
    model.ClmDateOfInjuryStart = claimant.data.clmDateOfInjuryStart;
    model.ClmDateOfInjuryEnd = claimant.data.clmDateOfInjuryEnd;
    model.ClmNote = claimant.data.clmPhone;
    model.ClmDOB = claimant.data.clmDOB;
    model.ClmInsuredParty = claimant.data.clmInsuredParty;
    model.ClmEmployer = claimant.data.clmEmployer;
    model.ClmInvoiceCaption = claimant.data.clmInvoiceCaption;
    model.ClmLanguage = claimant.data.clmLanguage;
    model.ClmWCABNumber = claimant.data.clmWCABNumber;

    this.setState({ model: model });

    this.setModalClaimantFormSearch();
  }

  // Interpreter Search
  setModalInterpreterFormSearch() {
    this.setState({
      modalInterpreterSearchForm: !this.state.modalInterpreterSearchForm,
    });
  }

  handleSearchInterpreterKeyDown(e) {
    if (e.target.value !== '' && e.keyCode === 13) {
      this.setState({ searchInterpreterName: e.target.value });
      this.setModalInterpreterFormSearch();
    }
  }

  handleSelectInterpreter(intrprtr) {
    let model = { ...this.state.model };

    model.IntId = intrprtr.data.intId;
    model.IntLastName = intrprtr.data.intLastName;
    model.IntFirstName = intrprtr.data.intFirstName;
    model.IntCellTxt = intrprtr.data.intCellTxt;
    model.IntPhoneOnly = intrprtr.data.intPhoneOnly;
    model.IntEmail = intrprtr.data.intEmail;
    model.IntNote = intrprtr.data.intNote;
    model.InHouseFlg = intrprtr.data.inHouseFlg;
    model.IntCity = intrprtr.data.intCity;
    model.IntStreet = intrprtr.data.intStreet;
    model.IntState = intrprtr.data.intState;
    model.IntZip = intrprtr.data.intZip;
    model.Rate = intrprtr.data.rate;
    model.HourMinimum = intrprtr.data.hourMinimum;
    model.Prorate = intrprtr.data.prorate;

    this.setState({ model: model }, () => {
      this.setModalInterpreterFormSearch();
    });
  }

  handleUpdatedInterpreter(intrprtr) {
    let model = { ...this.state.model };

    model.IntId = intrprtr.IntId;
    model.IntLastName = intrprtr.IntLastName;
    model.IntFirstName = intrprtr.IntFirstName;
    model.IntCellTxt = intrprtr.IntCellTxt;
    model.IntPhoneOnly = intrprtr.IntPhoneOnly;
    model.IntEmail = intrprtr.IntEmail;
    model.IntNote = intrprtr.IntNote;
    model.InHouseFlg = intrprtr.InHouseFlg;
    model.IntCity = intrprtr.IntCity;
    model.IntStreet = intrprtr.IntStreet;
    model.IntState = intrprtr.IntState;
    model.IntZip = intrprtr.IntZip;
    model.Rate = intrprtr.Rate;
    model.HourMinimum = intrprtr.HourMinimum;
    model.Prorate = intrprtr.Prorate;

    this.setState({ model: model }, () => {});
  }

  // Interpreter
  handleInterpreterNameClick() {
    if (this.state.model.IntId !== null && this.state.model.IntId !== '') {
      FetchData('/getinterpreters', 'POST', this.user.token, {
        IntId: this.state.model.IntId,
        ShowAll: true,
      }).then((data) => {
        var intData = data[0];

        this.setState((prevState) => ({
          interpreter: {
            EventType: 'update',
            IntId: intData.intId,
            IntLastName: intData.intLastName,
            IntFirstName: intData.intFirstName,
            IntGender: intData.intGender,
            IntPronoun: intData.intPronoun,
            IntEmail: intData.intEmail,
            IntCellTxt: intData.intCellTxt,
            IntPhoneOnly: intData.intPhoneOnly,
            IntFax: intData.intFax,
            IntBeeper: intData.intBeeper,
            IntStreet: intData.intStreet,
            IntCity: intData.intCity,
            IntState: intData.intState,
            IntZip: intData.intZip,
            IntCountry: intData.intCountry,
            IntSSINumber: intData.intSSINumber,
            IntActiveFlg: intData.intActiveFlg,
            IntCorporationFlg: intData.intCorporationFlg,
            DBA: intData.dBA,
            InHouseFlg: intData.inHouseFlg,
            UnVettedFlg: intData.vnVettedFlg,
            EmergencyContact: intData.emergencyContact,
            UnavailableReason: intData.unavailableReason,
            BankName: intData.bankName,
            BankAccount: intData.bankAccount,
            BankRoute: intData.bankRoute,
            Rate: intData.rate,
            HourMinimum: intData.hourMinimum,
            Prorate: intData.prorate,
            ConfCallRate: intData.confCallRate,
            BusinessCardRequestDate: intData.businessCardRequestDate,
            BusinessCardRequestToProcessFlg:
              intData.businessCardRequestToProcessFlg,
            IntNote: intData.intNote,
            ReferredBy: intData.referredBy,
            CreateDateTime: intData.createDateTime,
            CreateByUserId: intData.createByUserId,
            UpdateByUserId: intData.updateByUserId,
            UpdateDateTime: intData.updateDateTime,
            IsDeletedFlg: intData.isDeletedFlg,
            CreatedBy: intData.createdBy,
            UpdatedBy: intData.updatedBy,
          },
        }));
        this.setModalInterpreterForm();
      });
    }
  }

  setModalInterpreterForm() {
    this.setState({ modalInterpreter: !this.state.modalInterpreter });
  }

  handleSaveEventInterpreterFormSuccess(alert) {
    this.setState(
      {
        modalInterpreter: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        this.handleUpdatedInterpreter(alert.model);
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, 3000);
      },
    );
  }

  // Provider Search
  setModalProviderFormSearch() {
    this.setState({
      modalProviderSearchForm: !this.state.modalProviderSearchForm,
    });
  }

  handleSearchProviderKeyDown(e) {
    if (e.target.value !== '' && e.keyCode === 13) {
      this.setState({ searchProviderName: e.target.value });
      this.setModalProviderFormSearch();
    }
  }

  handleSelectProvider(provider) {
    let model = this.state.model;
    model.ProvId = provider.data.provId;
    const provTitle = provider.data.provTitle ? ', ' + provider.data.provTitle : '';
    model.ProviderName =
      provider.data.provFirstName + ' ' + provider.data.provLastName + provTitle;
    model.ProvEmail = provider.data.provEmail;
    model.ProvNote = provider.data.provNote;
    model.AptName = provider.data.provSpeciality;
    model.AptPhone = provider.data.provPhone;
    model.AptStreet = provider.data.provStreet;
    model.AptCity = provider.data.provCity;
    model.AptState = provider.data.provState;
    model.AptZip = provider.data.provZip;
    model.ProvId = provider.data.provId;
    model.AptDirection = ''; //provider.provNote;

    this.setState({ model: model });

    this.setModalProviderFormSearch();
  }

  // Transportation
  setModalTransportation() {
    this.setState({ modalTransportation: !this.state.modalTransportation });
  }

  //
  setModalClient() {
    this.setState({ modalClient: !this.state.modalClient });
  }

  showClient(clientId) {
    let searchModel = {
      ClientId: clientId,
      ClientName: '',
    };

    FetchData('/getclients', 'POST', this.user.token, searchModel).then(
      (data) => {
        var clientData = data[0];

        this.setState((prevState) => ({
          client: {
            EventType: 'update',
            ClientId: clientData.clientId,
            ClientAbbrv: clientData.clientAbbrv,
            ClientPhone: clientData.clientPhone,
            ClientPhone2: clientData.clientPhone2,
            ClientPhoneFax: clientData.clientPhoneFax,
            ClientName: clientData.clientName,
            ClientMailStreet: clientData.clientMailStreet,
            ClientMailStreet2: clientData.clientMailStreet2,
            ClientMailCity: clientData.clientMailCity,
            ClientMailState: clientData.clientMailState,
            ClientMailZip: clientData.clientMailZip,
            ClientStreet: clientData.clientStreet,
            ClientStreet2: clientData.clientStreet2,
            ClientCity: clientData.clientCity,
            ClientState: clientData.clientState,
            ClientZip: clientData.clientZip,
            ClientCountry: clientData.clientCountry,
            ClientDiscount: clientData.clientDiscount,
            ClientNotes: clientData.clientNotes,
            ClientCreditCard: clientData.clientCreditCard,
            ClientEmailForInvoice: clientData.clientEmailForInvoice,
            ClientEmail: clientData.clientEmail,
            ClientWebsite: clientData.clientWebsite,
            ClientOrg: clientData.clientOrg,
            ClientBillRateType: clientData.clientBillRateType,
            ClientInactiveFlg: clientData.clientInactiveFlg,
            CreateDateTime: clientData.createDateTime,
            CreateByUserId: clientData.createByUserId,
            UpdateByUserId: clientData.updateByUserId,
            UpdateDateTime: clientData.updateDateTime,
            IsDeletedFlg: clientData.isDeletedFlg,
          },
        }));
        this.setModalClient();
      },
    );
  }

  setModalFollowup() {
    this.setState({ modalFollowUp: !this.state.modalFollowUp });
  }

  setModalPrintPreview() {
    this.setState({ modalPrintPreview: !this.state.modalPrintPreview }, () => {
      setTimeout(() => this.getJobHistory(this.state.model.JobId), 4000);
    });
  }

  setModalClaimantJobs() {
    this.setState({ modalClaimantJobs: !this.state.modalClaimantJobs });
  }

  setModalTroubleTicket() {
    this.setState({ modalTroubleTicket: !this.state.modalTroubleTicket });
  }

  openTroubleTicketForm() {
    const m = this.state.model;
    this.setState(
      {
        troubleTicketModel: {
          EventType: 'insert',
          TroubleTicketId: null,
          TroubleTicketNumber: null,
          JobId: m.JobId,
          JobNum: m.JobNum,
          UserId: null,
          ClaimantId: m.ClmId || null,
          ClientId: m.ClientId || null,
          RepId: m.RepId || null,
          ProvId: m.ProvId || null,
          IntId: m.IntId || null,
          Description: '',
          WorkFlowId: '',
          TroubleTicketStatus: 'Open',
          Priority: '',
          Category: '',
          Source: '',
          AssignedToUserId: null,
          DueDate: null,
          ResolutionNotes: '',
          CreateDateTime: null,
          CreateByUserId: null,
          UpdateByUserId: null,
          UpdateDateTime: null,
          IsDeletedFlg: false,
          ClientName: m.ClientName || '',
          ClientAbbrv: m.ClientAbbrv || '',
          ClmFirstName: m.ClmFirstName || '',
          ClmLastName: m.ClmLastName || '',
          RepFirstName: m.RepFirstName || '',
          RepLastName: m.RepLastName || '',
          IntFirstName: m.IntFirstName || '',
          IntLastName: m.IntLastName || '',
          ProvOfficeName: m.ProviderName || '',
          AssignedToFirstName: '',
          AssignedToLastName: '',
        },
      },
      () => this.setModalTroubleTicket(),
    );
  }

  handleSaveTroubleTicketSuccess(alert) {
    this.setState({
      modalTroubleTicket: alert.modal,
      alert: {
        color: alert.color,
        message: alert.message,
        isOpen: true,
      },
    });
    window.setTimeout(() => {
      this.setState({ alert: { isOpen: false } });
    }, Timeout);
  }

  handleSaveEventClientSuccess(alert) {
    this.setState(
      {
        modalClient: alert.modal,
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, 3000);
      },
    );
  }

  handleTransportationClick() {
    this.setState((prevState) => ({
      transportation: {
        EventType: 'insert',
        TransportationId: null,
        JobId: this.state.model.JobId,
        JobNum: this.state.model.JobNum,
        CallerState: '',
        FailedTransportFlg: false,
        CallerName: '',
        AuthorizedBy: '',
        CallerEmail: '',
        CallerCompany: '',
        CallerPhone: '',
        AmbulatoryFlg: false,
        RoundTripFlg: false,
        Ground: null,
        AirFlg: false,
        LodgingFlg: false,
        Other: '',
      },
    }));
    this.setModalTransportation();
  }

  cancelIntConfirmed() {
    if (this.state.model.JobId !== null) {
      var data = {
        Jobid: this.state.model.JobId,
        UpdateByUserId: this.user.userid,
        UserEmail: this.user.email,
      };

      FetchData('/cancelintconfirmed', 'POST', this.user.token, data).then(
        (data) => {
          this.handleSaveEventSuccess({
            message: data === 'Success' ? 'Cancel Int. Confirm' : data,
            modal: true,
            color: data === 'Success' ? 'success' : 'warning',
          });

          if (data === 'Success') {
            let model = { ...this.state.model };
            model.IntConfFlg = false;
            this.setState({ model: model }, () => {
              this.getJobHistory(this.state.model.JobId);
            });
          }
        },
      );
    }
  }

  confirmDelete() {
    if (this.state.model.JobId !== null) {
      var note = window.prompt('Why are you deleting this job?', '');
      if (note !== null) {
        var data = {
          JobNum: this.state.model.JobNum,
          UpdateByUserId: this.user.userid,
          CreateByUserId: this.state.model.CreateByUserId,
          UserEmail: this.user.email,
          UserFirstName: this.user.firstname,
          InvoiceNote: note,
        };

        this.props.setFetchingData(true);

        FetchData('/deletejob', 'POST', this.user.token, data).then((data) => {
          if (data === 'Success') {
            this.props.handleSaveEventSuccess({
              message: data,
              modal: data === 'Success' ? false : true,
              color: data === 'Success' ? 'success' : 'warning',
            });
          } else {
            this.props.setFetchingData(false);
            this.handleSaveEventSuccess({
              message: data,
              modal: data === 'Success' ? false : true,
              color: data === 'Success' ? 'success' : 'warning',
            });
          }
        });
      }
    }
  }

  showMap() {
    let model = { ...this.state.model };

    var origin = model.IntStreet.replace(/\s/g, '+').replace(
      /[^a-zA-Z0-9]/g,
      '+',
    );
    var orgCity = model.IntCity;
    var orgState = model.IntState;
    var orgZip = model.IntZip;

    if (orgCity !== '') origin += ',+' + orgCity.replace(/\s/g, '+');
    if (orgState !== '') origin += '+' + orgState.replace(/\s/g, '+');
    if (orgZip !== '') origin += '+' + orgZip.replace(/\s/g, '+');

    var dest = model.AptStreet.replace(/\s/g, '+').replace(
      /[^a-zA-Z0-9]/g,
      '+',
    );
    var desCity = model.AptCity;
    var desState = model.AptState;
    var desZip = model.AptZip;

    if (desCity !== '') dest += ',+' + desCity.replace(/\s/g, '+');
    if (desState !== '') dest += '+' + desState.replace(/\s/g, '+');
    if (desZip !== '') dest += '+' + desZip.replace(/\s/g, '+');

    var url =
      'https://www.google.com/maps/dir/?api=1&origin=' +
      origin +
      '&destination=' +
      dest +
      '&travelmode=driving';
    window.open(url, '_blank');
  }

  async handleViewJobHistoryFile(item) {
    let body = {
      JobHistoryId: item.jobHistoryId,
    };

    await FetchFile('/getjobhistoryfile', 'POST', this.user.token, body).then(
      (blob) => {
        if (!blob || blob.size === 0) {
          this.handleSaveEventSuccess({ color: 'warning', message: 'No file returned.', modal: false });
          return;
        }
        openFileInNewTab(blob, item.fileName);
      },
    );
  }

  async handleOpenJobFromHistory(jobNum) {
    const normalizedJobNum =
      typeof jobNum === 'number' ? jobNum.toString() : (jobNum || '').trim();

    if (normalizedJobNum === '') {
      this.handleSaveEventSuccess({
        message: 'Follow up job number is missing.',
        modal: false,
        color: 'warning',
      });
      return;
    }

    const searchModel = {
      JobNum: normalizedJobNum,
      StartDate: null,
      EndDate: null,
    };

    try {
      const data = await FetchData(
        '/getworkorders',
        'POST',
        this.user.token,
        searchModel,
      );
      const jobs = Array.isArray(data) ? data : [];
      const targetJob = jobs.find(
        (job) =>
          String(job.jobNum || job.JobNum || job.jobnum || '').trim() ===
          normalizedJobNum,
      );
      const jobId = targetJob ? targetJob.jobId || targetJob.JobId : null;

      if (jobId) {
        window.open(`/?jobid=${jobId}`, '_blank');
      } else {
        this.handleSaveEventSuccess({
          message: `Unable to find job ${normalizedJobNum}.`,
          modal: false,
          color: 'warning',
        });
      }
    } catch (error) {
      console.error('Error opening follow-up job', error);
      this.handleSaveEventSuccess({
        message: 'Unable to open follow-up job right now.',
        modal: false,
        color: 'warning',
      });
    }
  }

  handleViewInvoice = (event) => {
    let model = {
      jobId: this.state.model.JobId,
      jobNum: this.state.model.JobNum,
    };

    this.props.viewInvoice(model);
  };

  renderJobHistoryTable() {
    return (
      <WorkOrderFormTableJobHistory
        state={this.state}
        handleViewJobHistoryFile={this.handleViewJobHistoryFile}
        handleNewJobNoteViewClick={this.handleNewJobNoteViewClick}
        handleDeleteJobHistory={this.handleDeleteJobHistory}
        handleOpenJobFromHistory={this.handleOpenJobFromHistory}
        jobHistory={this.state.jobHistoryList}
      ></WorkOrderFormTableJobHistory>
    );
  }

  renderReceivablesTable() {
    return (
      <WorkOrderFormTableReceivables
        state={this.state}
        jobInvLine={this.state.jobInvLineList}
        handleEditJobInvLineClick={this.handleEditJobInvLineClick}
        handleDeleteJobInvLineClick={this.handleDeleteJobInvLineClick}
      ></WorkOrderFormTableReceivables>
    );
  }

  render() {
    let isNew = this.state.model.JobId === null ? true : false;

    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const { model } = this.state;
    const draggableNodeRef = this.draggableRef;

    const parseTimeValue = (value) => {
      if (value === null || value === undefined) {
        return null;
      }

      if (typeof value === 'string') {
        const trimmedValue = value.trim();
        if (!trimmedValue) {
          return null;
        }

        const timeFormats = ['h:mm A', 'hh:mm A', 'HH:mm'];
        const parsed = moment(trimmedValue, timeFormats, true);
        if (parsed.isValid()) {
          return parsed;
        }

        const fallbackParsed = moment(trimmedValue);
        return fallbackParsed.isValid() ? fallbackParsed : null;
      }

      const parsedDate = moment(value);
      return parsedDate.isValid() ? parsedDate : null;
    };

    let durationDisplay = '';
    const jobStart = parseTimeValue(model.JobTime);
    let jobFinish = parseTimeValue(model.FinishTimeString);
    if (!jobFinish) {
      jobFinish = parseTimeValue(model.FinishTime);
    }

    if (jobStart && jobFinish) {
      const finishForCalc = jobFinish.clone();
      if (finishForCalc.isBefore(jobStart)) {
        finishForCalc.add(1, 'day');
      }

      const totalMinutes = finishForCalc.diff(jobStart, 'minutes');
      if (totalMinutes >= 0) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        durationDisplay = `${hours}:${minutes.toString().padStart(2, '0')}`;
      }
    }

    let jobHistoryContent = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderJobHistoryTable()
    );

    let receivablesContent = this.state.loading ? (
      <p>
        <em>Loading...</em>
      </p>
    ) : (
      this.renderReceivablesTable()
    );

    return (
      <Draggable
        handle=".work-order-form-handle"
        onDrag={this.handleDrag}
        nodeRef={draggableNodeRef}
        {...dragHandlers}
      >
        <div ref={draggableNodeRef}>
          <Modal
            id="woForm"
            isOpen={this.props.modal}
            toggle={this.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '1280px',
              height: '480px',
              maxWidth: '100%',
            }}
            backdrop="static"
            keyboard={false} // Disable modal's keyboard handling to prevent conflicts
          >
            <ModalHeader className="work-order-form-handle handle">
              {!isNew &&
              (this.props.model.JobNum !== null ||
                this.state.model.JobNum !== null) ? (
                <div>
                  <span style={{ color: 'red', fontSize: '14px' }}>
                    Job#: {this.props.model.JobNum || this.state.model.JobNum}
                  </span>{' '}
                  <span style={{ fontSize: '14px' }}>
                    Created:{' '}
                    {moment(
                      this.props.model.CreateDateTime ||
                        this.state.model.CreatedDateTime,
                    ).format('MM/DD/YYYY')}
                  </span>{' '}
                  <span style={{ fontSize: '14px' }}>
                    By:{' '}
                    {this.props.model.CreatedBy || this.state.model.CreatedBy}
                  </span>
                </div>
              ) : (
                'New Work Order'
              )}
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col style={{ textAlign: 'center' }}>
                  <Alert
                    color={this.state.alert.color}
                    isOpen={this.state.alert.isOpen}
                  >
                    {this.state.alert.message}
                  </Alert>
                </Col>
              </Row>
              <ReactTooltip
                className="tooltip"
                id="rtp2"
                place="top"
                type="dark"
                effect="solid"
                html={true}
              />
              <div>
                <Row>
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <Input
                        name="searchRepName"
                        type="text"
                        className="form-control-text"
                        placeholder="Search Rep"
                        value={this.state.searchRepName}
                        onChange={this.handleSearchChange}
                        onFocus={this.handleSearchFocus}
                        onKeyDown={this.handleSearchRepKeyDown}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                        spellCheck={false}
                      />{' '}
                      <Input
                        name="searchProviderName"
                        type="text"
                        className="form-control-text"
                        placeholder="Search Provider"
                        value={this.state.searchProviderName}
                        onChange={this.handleSearchChange}
                        onFocus={this.handleSearchFocus}
                        onKeyDown={this.handleSearchProviderKeyDown}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                        spellCheck={false}
                      />{' '}
                      <Input
                        name="searchInterpreterName"
                        type="text"
                        className="form-control-text"
                        placeholder="Search Interpreter"
                        value={this.state.searchInterpreterName}
                        onChange={this.handleSearchChange}
                        onFocus={this.handleSearchFocus}
                        onKeyDown={this.handleSearchInterpreterKeyDown}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                        spellCheck={false}
                      />{' '}
                      <Input
                        name="searchClaimantName"
                        type="text"
                        className="form-control-text"
                        placeholder="Search Claimant"
                        value={this.state.searchClaimantName}
                        onChange={this.handleSearchChange}
                        onFocus={this.handleSearchFocus}
                        onKeyDown={this.handleSearchClaimantKeyDown}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                        spellCheck={false}
                      />{' '}
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText size="sm" color="blue">
                        Caller Type:
                      </InputGroupText>
                      <select
                        name="CallerType"
                        value={this.state.model.CallerType ?? ''}
                        className="form-control form-control-text"
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value={1}>Adjuster</option>
                        <option value={2}>Doctor Office</option>
                        <option value={3}>Email</option>
                        <option value={4}>Insured/Clmnt</option>
                        <option value={5}>Law Office</option>
                        <option value={6}>Other</option>
                        <option value={7}>Follow-up</option>
                      </select>
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText>Caller Notes:</InputGroupText>
                      <Input
                        name="CallerNote"
                        className="form-control form-control-text"
                        innerRef={this.callerNoteRef}
                        value={this.state.model.CallerNote ?? ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  {/*<Col className="col-1">*/}
                  {/*    <span className="input-group-text">Job Status:</span>*/}

                  {/*</Col>*/}
                  <Col className="col-2">
                    <Button
                      className="btn-secondary-no-background form-control-text btn btn-secondary btn-sm"
                      onClick={() => {
                        this.props.setNextPrevData(-1);
                        this.setNextPrevData(-1);
                      }}
                    >
                      <img
                        src={UpIcon}
                        style={{ width: '16px', height: '16px' }}
                        alt="Prev"
                      />
                    </Button>
                    <Button
                      className="btn-secondary-no-background form-control-text btn btn-secondary btn-sm"
                      onClick={() => {
                        this.props.setNextPrevData(1);
                        this.setNextPrevData(1);
                      }}
                    >
                      <img
                        src={DownIcon}
                        style={{ width: '16px', height: '16px' }}
                        alt="Next"
                      />
                    </Button>
                  </Col>
                  <Col className="col-2">
                    <Button
                      color="secondary"
                      outline
                      className="btn"
                      size="sm"
                      data-for="rtp2"
                      data-tip="Alt-A Add Rep to Caller and Provider <br>
                                Alt-B Calculate billing<br>
                                Alt-C Choose Claimant<br>
                                Alt-G ACertA<br>
                                Alt-H A Exotic A<br>
                                Alt-I Choose interpreter<br>
                                Alt-J Claimant jobs<br>
                                Alt-L Add job description<br>
                                Alt-M Me as Interpreter<br>
                                Alt-N A Non-Cert A<br>
                                Alt-O New job note<br>
                                Alt-P Choose provider<br>
                                Alt-Q Set job date to 2011-11-11<br>
                                Alt-R Choose Rep<br>
                                Alt-S Save without closing<br>
                                Alt-T Insert Time Now<br>
                                Alt-U Has Followups<br>
                                Alt-W Print work order<br>
                                Alt-X Inserts today's date<br>
                                Alt-Y Edit claimant<br>
                                Alt-Z Add My Job note<br>
                                Alt-1 Open blank Job Description<br>
                                Alt-2 Insert conference call<br>
                                Alt-3 Insert message phone<br>
                                Alt-4 Insert phone"
                    >
                      HotKeys
                    </Button>
                    {this.state.model.JobId && (
                      <Button
                        color="secondary"
                        outline
                        className="btn"
                        size="sm"
                        style={{ marginLeft: '5px', fontWeight: 'bold' }}
                        onClick={this.openTroubleTicketForm}
                      >
                        Trouble Ticket
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col className="col-3">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '70px' }}>
                        Job Date:
                      </InputGroupText>
                      <Input
                        name="JobDateTime"
                        type="date"
                        className="form-control-text"
                        value={
                          this.state.model.JobDateTime === null
                            ? ''
                            : moment(this.state.model.JobDateTime).format(
                                'YYYY-MM-DD',
                              )
                        }
                        onChange={this.handleChange}
                      />
                      {this.state.model.JobDateTime === null ? null : (
                        <span
                          className="form-control-text"
                          style={{
                            color: 'red',
                            paddingl: '5px',
                            paddingTop: '5px',
                          }}
                        >
                          <small>
                            {moment(this.state.model.JobDateTime).format(
                              'dddd',
                            )}
                          </small>
                        </span>
                      )}
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Time:</InputGroupText>
                      <Input
                        name="JobTime"
                        type="text"
                        className="form-control-text"
                        placeholder="--:-- AM/PM"
                        value={this.state.model.JobTime ?? ''}
                        onChange={this.handleChange}
                        onBlur={this.handleJobTimeFieldChange}
                      />
                    </InputGroup>
                  </Col>
                <Col className="col-auto">
                    <InputGroup size="sm" className="trans-flags">
                      <InputGroupText className="nowrap">Trans Needed:</InputGroupText>
                      <Input
                        name="TransportationFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={!!this.state.model.TransportationFlg}
                        onChange={this.handleChange}
                      />

                      <InputGroupText className="nowrap ms-2">Trans Conf:</InputGroupText>
                      <Input
                        name="TransConfFlg"
                        type="checkbox"
                        className={
                          this.state.model.TransConfFlg
                            ? "input-checkbox input-checkbox-red-check"
                            : "input-checkbox input-checkbox-red"
                        }
                        checked={!!this.state.model.TransConfFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  {/*<Col className="col-1_5">*/}
                  {/*    <InputGroup size="sm">*/}
                  {/*        <InputGroupText>*/}
                  {/*            Trans Conf:*/}
                  {/*        </InputGroupText>*/}
                  {/*        <Input name="TransConfFlg" type="checkbox" className="input-checkbox input-checkbox-red" defaultChecked={this.state.model.TransConfFlg} onChange={this.handleChange} />*/}
                  {/*    </InputGroup>*/}
                  {/*</Col>*/}
                  <Col className="col-1">
                    <Button
                      className="btn-secondary-no-background form-control-text"
                      onClick={this.handleTransportationClick}
                    >
                      Transportation
                    </Button>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Work Flow:</InputGroupText>
                      <select
                        name="WorkFlowId"
                        className="form-control form-control-text"
                        value={this.state.model.WorkFlowId ?? ''}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value="Authorization">Authorization</option>
                        <option value="Booking">Booking</option>
                        <option value="Confirmation">Confirmation</option>
                        <option value="Pending">Pending</option>
                        <option value="Complete">Complete</option>
                      </select>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Remote Type:</InputGroupText>
                      <select
                        name="RemType"
                        className="form-control form-control-text"
                        value={this.state.model.RemType ?? ''}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        {this.state.remoteTypeList.map((jobType) => (
                          <option
                            key={jobType.jobInvLineCodeId}
                            value={jobType.jobInvLineCodeId}
                          >
                            {jobType.appointmentType}
                          </option>
                        ))}
                      </select>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Remote Host:</InputGroupText>
                      <select
                        name="RemHost"
                        className="form-control form-control-text"
                        value={this.state.model.RemHost ?? ''}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        {this.state.remoteHostList.map((jobType) => (
                          <option
                            key={jobType.jobInvLineCodeId}
                            value={jobType.jobInvLineCodeId}
                          >
                            {jobType.appointmentType}
                          </option>
                        ))}
                      </select>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Remote Clm Check:</InputGroupText>
                      <Input
                        name="RemClaimFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.RemClaimFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Remote Int Check:</InputGroupText>
                      <Input
                        name="RemIntFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.RemIntFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Remote Prov Check:</InputGroupText>
                      <Input
                        name="RemProvFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.RemProvFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Rep Authorized:</InputGroupText>
                      <Input
                        name="RepAuthorizedFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.RepAuthorizedFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Rep:</InputGroupText>
                      <button
                        style={{
                          color: 'blue',
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          paddingTop: 0,
                          cursor: 'pointer',
                          //width: '100%',
                          textAlign: 'left',
                        }}
                        className="form-control no-border text-area-no-background form-control-text-padding"
                        onClick={this.handleRepNameClick}
                      >
                        {this.state.model.RepFirstName}{' '}
                        {this.state.model.RepLastName}
                      </button>
                    </InputGroup>
                  </Col>
                  <Col className="col-3">
                    <InputGroup size="sm">
                      <InputGroupText>Phone:</InputGroupText>
                      {/*<Input type="text" className="no-border text-area-no-background form-control-text" readOnly="true" value={this.state.model.RepPhone} />*/}
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.RepPhone}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Email:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.RepEmail}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-1">
                    <InputGroup size="sm">
                      <InputGroupText>Client:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        <button
                          style={{
                            color: 'blue',
                            textDecoration: 'underline',
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            this.showClient(this.state.model.ClientId)
                          }
                        >
                          {this.state.model.ClientAbbrv}
                        </button>
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Client Phone:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.ClientPhone}
                      </label>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-3">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Clm Name:
                      </InputGroupText>
                      <button
                        style={{
                          color: 'green',
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          paddingTop: 0,
                          cursor: 'pointer',
                          //width: '100%',
                          textAlign: 'left',
                        }}
                        className="form-control no-border text-area-no-background form-control-text-padding"
                        onClick={this.handleClaimantNameClick}
                      >
                        {this.state.model.ClmLastName},{' '}
                        {this.state.model.ClmFirstName}
                      </button>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        {this.getClmNumberLabel()}
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmClaimNumber}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-3">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Phone:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmPhone}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-1">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Lang:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmLanguage}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-1">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        DOB:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmDOB === null
                          ? ''
                          : moment(this.state.model.ClmDOB).format('MM/DD/YY')}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Email:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        <strong>
                          {this.state.model.ClmStreet != null
                            ? 'TRANSPORTATION'
                            : this.state.model.ClmEmail}
                        </strong>
                      </label>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Employer:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmEmployer}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-1">
                  <InputGroup size="sm">
                    <InputGroupText className="no-border-green">
                      DoI:
                    </InputGroupText>

                    <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                      {(() => {
                        const start = this.state.model.ClmDateOfInjuryStart;
                        const end = this.state.model.ClmDateOfInjuryEnd;

                        if (!start) return "";

                        const startDate = new Date(start).toLocaleDateString();
                        const endDate = end ? new Date(end).toLocaleDateString() : null;

                        // Show range only if end exists and is different
                        if (endDate && endDate !== startDate) {
                          return `${startDate}-${endDate}`;
                        }

                        return startDate;
                      })()}
                    </label>
                  </InputGroup>
                </Col>
                  <Col className="col-1">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Insured:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmInsuredParty}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-1">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        DoL:
                      </InputGroupText>
                      <label className="form-control no-border-green text-area-no-background form-control-text-padding">
                        {this.state.model.ClmDateOfLossDate
                          ? moment(this.state.model.ClmDateOfLossDate).format('MM/DD/YYYY')
                          : this.state.model.ClmDateOfLoss}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Has Attorney:</InputGroupText>
                      <Input
                        name="ClmHasAttorney"
                        type="checkbox"
                        className="input-checkbox form-check-input"
                        checked={this.state.model.ClmHasAttorneyFlg}
                        disabled
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        CLM Status:
                      </InputGroupText>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>CLM Confirmation:</InputGroupText>
                      <Input
                        name="ClmConfFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.ClmConfFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <InputGroupText
                        className="no-border-green"
                        style={{ alignItems: 'unset' }}
                      >
                        Claimant Notes:
                      </InputGroupText>
                      <label
                        className="input-font-normal no-border-red text-area-no-background form-control-text-padding"
                        style={{ flexGrow: 1, flexBasis: '0%' }}
                      >
                        {this.state.model.ClmNote}
                      </label>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Interpreter:</InputGroupText>
                      <button
                        style={{
                          color: 'blue',
                          textDecoration: 'underline',
                          background: 'none',
                          border: 'none',
                          paddingTop: 0,
                          cursor: 'pointer',
                          //width: '100%',
                          textAlign: 'left',
                        }}
                        className="form-control no-border text-area-no-background form-control-text-padding"
                        onClick={this.handleInterpreterNameClick}
                      >
                        {this.state.model.IntLastName},{' '}
                        {this.state.model.IntFirstName}
                      </button>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Cell/Text:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.IntCellTxt}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Phone Only:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.IntPhoneOnly}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <Button
                        className="btn-secondary-no-background form-control-text"
                        size="sm"
                        id="btnCancelIntConf"
                        onClick={this.cancelIntConfirmed}
                      >
                        Cancel Int. Confirm
                      </Button>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Int. Confirmed:</InputGroupText>
                      <Input
                        name="IntConfFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.IntConfFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Rate:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.Rate}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Minimum:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.HourMinimum}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText>Overtime:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.Prorate}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Chk #:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.IntCheckNum}
                      </label>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-10">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border-green">
                        Note:
                      </InputGroupText>
                      <label
                        className="form-control no-border text-area-no-background form-control-text-padding"
                        style={{
                          flexGrow: 1,
                          flexBasis: '0%',
                          wordWrap: 'break-word',
                          whiteSpace: 'initial',
                        }}
                      >
                        {this.state.model.IntNote}
                      </label>
                    </InputGroup>
                  </Col>
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText>Chk Date:</InputGroupText>
                      <label className="form-control no-border text-area-no-background form-control-text-padding">
                        {this.state.model.IntCheckDate === null
                          ? null
                          : moment(this.state.model.IntCheckDate).format(
                              'MM/DD/YYYY',
                            )}
                      </label>
                    </InputGroup>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col className="col-7">
                    <InputGroup size="sm">
                      <Input
                        type="text"
                        name="ProviderName"
                        className="form-control-text"
                        placeholder="Provider"
                        value={this.state.model.ProviderName ?? ''}
                        onChange={this.handleChange}
                      />{' '}
                      <label
                        className="no-border text-area-no-background form-control-text-padding"
                        style={{ color: 'blue', paddingLeft: '12px' }}
                      >
                        Job Type:
                      </label>
                      <select
                        name="AppointmentTypeId"
                        className="form-control form-control-text"
                        value={this.state.model.AppointmentTypeId ?? ''}
                        onChange={this.handleChange}
                      >
                        {' '}
                        {this.state.jobTypeList.map((jobType) => (
                          <option
                            key={jobType.jobInvLineCodeId}
                            value={jobType.jobInvLineCodeId}
                            defaultValue={
                              this.state.model.AppointmentTypeId ===
                              jobType.jobInvLineCodeId
                            }
                          >
                            {jobType.appointmentType}
                          </option>
                        ))}
                      </select>{' '}
                      <Input
                        name="AptName"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt Name/ Specialty"
                        value={this.state.model.AptName ?? ''}
                        onChange={this.handleChange}
                      />{' '}
                      <Input
                        name="AptPhone"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt Phone"
                        maxLength={20}
                        style={{ width: '125px', flex: '0 0 125px' }}
                        value={this.state.model.AptPhone ?? ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-3">
                    <InputGroup
                      size="sm"
                      className="flex-nowrap align-items-center"
                    >
                      <InputGroupText>Provider Email:</InputGroupText>
                      <Input
                        type="text"
                        name="ProvEmail"
                        className="form-control-text"
                        placeholder="Provider Email"
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                        title={this.state.model.ProvEmail || ''}
                        value={this.state.model.ProvEmail || ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>{' '}
                  <Col className="col-2">
                    <InputGroup size="sm">
                      <InputGroupText className="input-group-text">
                        Provider Confirmation:
                      </InputGroupText>
                      <Input
                        name="ProvConfFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={this.state.model.ProvConfFlg}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                  <Row>{/*</Col>*/}</Row>
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <Input
                        name="AptStreet"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt Street"
                        value={this.state.model.AptStreet ?? ''}
                        onChange={this.handleChange}
                      />{' '}
                      <Input
                        name="AptCity"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt City"
                        value={this.state.model.AptCity ?? ''}
                        onChange={this.handleChange}
                      />{' '}
                      <Input
                        name="AptState"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt State"
                        value={this.state.model.AptState ?? ''}
                        onChange={this.handleChange}
                      />{' '}
                      <Input
                        name="AptZip"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt Zip"
                        value={this.state.model.AptZip ?? ''}
                        onChange={this.handleChange}
                      />{' '}
                      <Input
                        name="AptDirection"
                        type="text"
                        className="form-control-text"
                        placeholder="Appt Details"
                        value={this.state.model.AptDirection ?? ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row className="row-padding16">
                  <Col>{jobHistoryContent}</Col>
                  <Col className="col-3">
                    <InputGroup size="sm">
                      <InputGroupText className="no-border">
                        Provider Note:
                      </InputGroupText>
                      <textarea
                        name="ProvNote"
                        rows="3"
                        className="no-border form-control-text"
                        style={{ width: '100%' }}
                        value={this.state.model.ProvNote ?? ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                    <InputGroup size="sm">
                      <InputGroupText className="no-border">
                        Interpreter Appt Directions:
                      </InputGroupText>
                      <textarea
                        name="IntApptNotes"
                        rows="3"
                        className="no-border form-control-text"
                        style={{ width: '100%' }}
                        value={this.state.model.IntApptNotes ?? ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                    <InputGroup size="sm">
                      <InputGroupText className="no-border">
                        Invoice Notes:
                      </InputGroupText>
                      <textarea
                        name="InvoiceNote"
                        rows="4"
                        className="no-border form-control-text"
                        style={{ width: '100%' }}
                        value={this.state.model.InvoiceNote ?? ''} // Use value prop instead of children
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                {!isNew && (
                  <Row>
                    <Col>
                      <InputGroup size="sm">
                        <Button
                          className="btn-secondary-no-background form-control-text"
                          size="sm"
                          onClick={this.handleNewJobNoteClick}
                        >
                          New Job Note
                        </Button>
                        <span className="input-group-text">Start:</span>
                        <label className="no-border text-area-no-background form-control form-control-text-padding">
                          {this.state.model.JobTime}
                        </label>
                        <span className="input-group-text">Finish:</span>
                     <Input
                      name="FinishTimeString"
                      type="text"
                      className="form-control-text"
                      placeholder="--:-- AM/PM"
                      value={this.state.model.FinishTimeString ?? ''}
                      onChange={(e) => {
                        const raw = e.target.value;

                        this.setState((prev) => ({
                          model: {
                            ...prev.model,
                            FinishTimeString: raw,
                            ClearedFinishTimeFlg: raw.trim() === '',
                          },
                        }));
                      }}
                      onBlur={this.handleJobTimeFieldChange}
                    />


                        {/*<input name="FinishTimeString" type="time" className="form-control form-control-text" value={this.state.model.FinishTimeString === null ? "" : this.state.model.FinishTimeString} onChange={this.handleTimeFieldChange} />*/}
                        <span
                          className="input-group-text"
                          style={{ paddingLeft: '3px', paddingRight: '3px' }}
                        >
                          Dur:
                        </span>
                        <span className="input-group-text">
                          {durationDisplay}
                        </span>
                        <span className="input-group-text">F:</span>
                        <Input
                          name="FailedFlg"
                          type="checkbox"
                          className="input-checkbox form-check-input"
                          defaultChecked={this.state.model.FailedFlg}
                          onChange={this.handleChange}
                        />
                        <span className="input-group-text">IntFee:</span>
                        <input
                          name="IntFee"
                          type="number"
                          className="form-control form-control-text"
                          value={
                            this.state.model.IntFee <= 0
                              ? ''
                              : this.state.model.IntFee
                          }
                          // onKeyUp={this.handleOnKeyup}
                          onChange={this.handleChange}
                          // onBlur={this.handleNumberFieldBlur}
                        />
                        <span className="input-group-text">OTFee:</span>
                        <input
                          name="IntOTFee"
                          type="number"
                          className="form-control form-control-text"
                          value={
                            this.state.model.IntOTFee <= 0
                              ? ''
                              : this.state.model.IntOTFee
                          }
                          // onKeyUp={this.handleOnKeyup}
                          onChange={this.handleChange}
                          // onBlur={this.handleNumberFieldBlur}
                        />
                        <span className="input-group-text">Oth:</span>
                        <input
                          name="IntFeeOther"
                          type="number"
                          className="form-control form-control-text"
                          value={
                            this.state.model.IntFeeOther <= 0
                              ? ''
                              : this.state.model.IntFeeOther
                          }
                          // onKeyUp={this.handleOnKeyup}
                          onChange={this.handleChange}
                          // onBlur={this.handleNumberFieldBlur}
                        />
                        <span
                          style={{
                            backgroundColor: '#e9ecef',
                            width: '4px',
                            height: '100%',
                            display: 'inline-block',
                          }}
                        ></span>
                        <input
                          name="IntFeeNote"
                          type="text"
                          className="form-control form-control-text"
                          placeholder="Other Fee"
                          style={{ paddingLeft: '6px' }}
                          value={this.state.model.IntFeeNote ?? ''}
                          onChange={this.handleChange}
                        />
                        <Button
                          className="btn btn-secondary-no-background form-control-text"
                          size="sm"
                          onClick={this.showMap}
                        >
                          Show Map
                        </Button>
                        <span className="input-group-text">Disc:</span>
                        <input
                          name="JobDiscount"
                          type="number"
                          className="form-control-text"
                          style={{ width: '50px' }}
                          value={this.state.model.JobDiscount ?? ''}
                          onChange={this.handleChange}
                        />{' '}
                        {'  '}
                        <Button
                          className="btn-secondary-no-background form-control-text"
                          size="sm"
                        >
                          <img
                            src={DownloadIcon}
                            onClick={this.handleViewInvoice}
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer',
                            }}
                            alt="Delete"
                          />
                        </Button>
                        <Button
                          className="btn-secondary-no-background form-control-text"
                          size="sm"
                          onClick={this.confirmDelete}
                        >
                          <img
                            src={DeleteIcon}
                            style={{
                              width: '16px',
                              height: '16px',
                              cursor: 'pointer',
                            }}
                            alt="Delete"
                          />
                        </Button>
                        <span className="input-group-text">R:</span>
                        <Input
                          name="BillReviewedFlg"
                          type="checkbox"
                          className="input-checkbox"
                          defaultChecked={this.state.model.BillReviewedFlg}
                          onChange={this.handleChange}
                        />
                        <span className="input-group-text">Aud:</span>
                        <Input
                          name="AuditFlg"
                          type="checkbox"
                          className="input-checkbox"
                          defaultChecked={this.state.model.AuditFlg}
                          onChange={this.handleChange}
                        />
                        <span className="input-group-text">PurpleRpt:</span>
                        <Input
                          name="PurpleReportFlg"
                          type="checkbox"
                          className="input-checkbox"
                          defaultChecked={this.state.model.PurpleReportFlg}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                )}
                <Row style={{ width: '99.98%' }}>
                  <Col>{receivablesContent}</Col>
                </Row>
              </div>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Modal>

          {this.state.modalWorkOrderNoteForm && (
            <WorkOrderNoteForm
              modal={this.state.modalWorkOrderNoteForm}
              model={this.state.jobHistory}
              alert={this.props.alert}
              setModal={this.setModalWorkOrderNoteForm}
              handleSaveEventSuccess={
                this.handleSaveEventWorkOrderNoteFormSuccess
              }
            />
          )}
          {this.state.modalWorkOrderJobInvLine && (
            <WorkOrderJobInvLine
              model={this.state.jobInvLine}
              modal={this.state.modalWorkOrderJobInvLine}
              alert={this.state.alert}
              setModal={this.setModalWorkOrderJobInvLine}
              handleSaveEventSuccess={
                this.handleSaveEventWorkOrderJobInvLineSuccess
              }
            />
          )}
          {this.state.modalRepSearchForm && (
            <RepFormSearch
              modal={this.state.modalRepSearchForm}
              alert={this.props.alert}
              setModal={this.setModalRepFormSearch}
              RepName={this.state.searchRepName}
              allowNew={true}
              client={this.state.model}
              handleDoubleClick={this.handleSelectRep}
              setFetchingData={this.props.setFetchingData}
            />
          )}
          {this.state.modalClaimantSearchForm && (
            <ClaimantFormSearch
              modal={this.state.modalClaimantSearchForm}
              alert={this.props.alert}
              setModal={this.setModalClaimantFormSearch}
              Name={this.state.searchClaimantName}
              workorder={this.state.model}
              handleDoubleClick={this.handleSelectClaimant}
              setFetchingData={this.props.setFetchingData}
            />
          )}
          {this.state.modalInterpreterSearchForm && (
            <InterpreterFormSearch
              modal={this.state.modalInterpreterSearchForm}
              alert={this.props.alert}
              setModal={this.setModalInterpreterFormSearch}
              Name={this.state.searchInterpreterName}
              handleDoubleClick={this.handleSelectInterpreter}
              setFetchingData={this.props.setFetchingData}
            />
          )}
          {this.state.modalProviderSearchForm && (
            <ProviderFormSearch
              modal={this.state.modalProviderSearchForm}
              setModal={this.setModalProviderFormSearch}
              alert={this.props.alert}
              Name={this.state.searchProviderName}
              handleDoubleClick={this.handleSelectProvider}
              setFetchingData={this.props.setFetchingData}
            />
          )}
          {this.state.modalTransportation && (
            <WorkOrderTransportationForm
              model={this.state.transportation}
              modal={this.state.modalTransportation}
              alert={this.props.alert}
              setModal={this.setModalTransportation}
              job={this.state.model}
              handleSaveEventSuccess={
                this.handleSaveEventWorkOrderTransportationFormSuccess
              }
            />
          )}
          {this.state.modalRep && (
            <RepForm
              model={this.state.rep}
              modal={this.state.modalRep}
              alert={this.props.alert}
              setModal={this.setModalRepForm}
              handleSaveEventSuccess={this.handleSaveEventRepFormSuccess}
              showViewPortal={true}
            />
          )}
          {this.state.modalClaimant && (
            <ClaimantForm
              model={this.state.claimant}
              modal={this.state.modalClaimant}
              alert={this.props.alert}
              setModal={this.setModalClaimantForm}
              handleSaveEventSuccess={this.handleSaveEventClaimantFormSuccess}
            />
          )}
          {this.state.modalInterpreter && (
            <InterpreterForm
              model={this.state.interpreter}
              modal={this.state.modalInterpreter}
              alert={this.props.alert}
              setModal={this.setModalInterpreterForm}
              handleSaveEventSuccess={
                this.handleSaveEventInterpreterFormSuccess
              }
            />
          )}
          {this.state.modalClient && (
            <ClientForm
              model={this.state.client}
              modal={this.state.modalClient}
              alert={this.state.alert}
              setModal={this.setModalClient}
              handleSaveEventSuccess={this.handleSaveEventClientSuccess}
            />
          )}
          {this.state.modalFollowUp && (
            <WorkOrderFollowUp
              model={this.state.model}
              modal={this.state.modalFollowUp}
              alert={this.state.alert}
              setModal={this.setModalFollowup}
              handleSaveEventSuccess={
                this.handleSaveEventWorkOrderNoteFormSuccess
              }
            />
          )}
          {this.state.modalPrintPreview && (
            <WorkOrderPrintPreview
              model={this.state.model}
              modal={this.state.modalPrintPreview}
              alert={this.state.alert}
              setModal={this.setModalPrintPreview}
              jobHistoryList={this.state.jobHistoryList}
            />
          )}
          {this.state.modalClaimantJobs && (
            <WorkOrderClaimantJobs
              model={this.state.model}
              modal={this.state.modalClaimantJobs}
              alert={this.state.alert}
              setModal={this.setModalClaimantJobs}
            />
          )}
          {this.state.modalTroubleTicket && (
            <TroubleTicketForm
              model={this.state.troubleTicketModel}
              modal={this.state.modalTroubleTicket}
              alert={{ color: '', message: '', isOpen: false }}
              setModal={this.setModalTroubleTicket}
              handleSaveEventSuccess={this.handleSaveTroubleTicketSuccess}
            />
          )}
        </div>
      </Draggable>
    );
  }
}
